// import axios from 'axios'
// import React, { useEffect, useState, useCallback, useContext, useRef } from 'react'
// import { Enroll_fun, fetchBeneficiaries, getSavingPlan_fun, postSchemaSave } from '../api/Pageapi';
// import { useRazorpay } from "react-razorpay";
// import toast, { useToaster } from 'react-hot-toast';
// import { Logindetail } from '../context/Logindetail';
// import { useNavigate } from 'react-router-dom';
// import { Shimmer } from 'react-shimmer';
// import { Digitalscheme_fun, Getdigital_trans, GetPlanbenefit, Savedigitalplan, SavedigitalSilverplan } from '../api/RouteScheme2';
// import { GoldPlant_fun, SaveGoldplan } from '../api/RouteScheme3';
// import { Footerpages } from '../context/Footerpages';
// import { schemeplans } from '../api/Controllapi';
// import AOS from 'aos';
// import { SchemeDetails } from '../context/SchemeDetails';
// import { capture_payment } from '../api/Controllapi';
// import { Arrow90degLeft, ArrowLeft, ArrowUp, ArrowUpShort, ChevronDown, X } from 'react-bootstrap-icons';
// import { RazarDetails } from '../context/razarApi';
// import { Snackbar, Alert } from '@mui/material';
// import { FaCopy } from 'react-icons/fa';
// import { Modal, Button } from "react-bootstrap";
// import DigitalSilverScheme from '../dashboard/DigitalSilverSchemes';
// import { getShemesSchedule } from "../api/Pageapi"
// import { Getdigital_silver_trans } from "../api/RouteScheme2"
// import { GetGoldPlantApi } from "../api/RouteScheme3"
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Scrollbar } from "swiper/modules";
// import { Autoplay } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/scrollbar";



// import Select from 'react-select';



// export default function Schemes({ setopenSchemes, setting_data }) {



//     //new
//     const [new_razar_key, setNew_razar_key] = useState(0)






//     const fetchKey = async () => {
//         try {
//             const response = await axios.get(`${process.env.REACT_APP_BASE_URL}razorpay_key`);
//             if (response?.data?.razorpay_key) {
//                 const newKey = response.data.razorpay_key;
//                 // const storedKey = localStorage.getItem('razorpay_key');

//                 if (newKey) {
//                     // Key is different, update state and localStorage
//                     setNew_razar_key(newKey);
//                     // localStorage.setItem('razorpay_key', newKey);
//                 }
//                 // else: keys are same, no update needed
//             } else {
//                 throw new Error("Invalid response format");
//             }
//         } catch (error) {
//             console.error('Failed to fetch Razorpay key:', error);
//             // toast.error("Unable to load Razorpay key. Please try again later.");
//         }
//     };


//     ///

//     //  const new_razar_key = localStorage.getItem('razorpay_key');

//     // console.log("new razar.......from scheme...........",new_razar_key)

//     const router = useNavigate();

//     //added key
//     const RAZAR_KEY = new_razar_key;




//     //default key
//     // const RAZAR_KEY = "rzp_test_K7CipNQYyyMPiS";




//     // const RAZAR_KEY = "rzp_live_FZ6iVw5tcRGpW5";

//     // const RAZAR_KEY= razorpayKey;




//     const { token, detail_info, setdetail_info } = useContext(Logindetail)



//     const { setschemelist } = useContext(SchemeDetails)
//     const [scheme_list, setscheme_list] = useState({});
//     const { error, isLoading: isRazorpayLoading, Razorpay } = useRazorpay();
//     const [showRazorpayModal, setShowRazorpayModal] = useState(false);
//     const [shemData, setSchemaData] = useState()
//     const [price, setprice] = useState();
//     const [isLoading, setisLoading] = useState(true);
//     const [benfic, setbenfic] = useState([]);
//     const [DigitaScheme, setDegitalScheme] = useState({})
//     const [digitalSilverPlan, setDigitalSilverPlan] = useState()
//     const [Benifitid, setBenifitid] = useState()
//     const [Goldplant_data, setGoldplant_data] = useState()
//     const [checked, setchecked] = useState(false)
//     const { footerpage } = useContext(Footerpages)
//     const fromsubmit = useRef()
//     const [ChargeAmt, setChargeAmt] = useState()
//     const [benificid, setbenificid] = useState('')
//     const [process_type, setprocess_type] = useState()
//     const [clientamount, setclientamount] = useState()
//     const [Transactionid, setTranscationid] = useState()
//     const [transfile, settransfile] = useState()
//     const [file1, setfile1] = useState()
//     const [spinner, setspinner] = useState()
//     const [Enroll_data, setEnroll_data] = useState()


//     // const navi = useNavigate()



//     const logout = () => {
//         localStorage.removeItem("green_login")
//         localStorage.removeItem("phone")
//         localStorage.removeItem("green_token")
//         localStorage.removeItem("kyc")
//         router('/');
//         setdetail_info();
//     }

//     const handlefectch = () => {
//         fetchBeneficiaries()
//             .then(res => {
//                 setbenfic(res?.data)
//                 setisLoading(false);
//                 if (res?.data?.status == 403) {
//                     logout();
//                 }
//             }).catch(err => {
//                 // console.log('err', err.message);
//                 setisLoading(false)
//             });
//     }

//     useEffect(() => {
//         if (detail_info && token) {
//             handlefectch()
//         }
//     }, [detail_info?.id])

//     useEffect(() => {
//         fetchKey()
//     }, [])


//     // 1 plan
//     const handlePayment = useCallback(async () => {

//         const options = {
//             key: RAZAR_KEY,
//             amount: (clientamount) * 100,
//             currency: "INR",
//             name: 'Greenheap',
//             description: 'Greenheap',
//             image: "/assets/iocns/__Fav Icon.png",
//             handler: (res) => {
//                 const transactionId = res.razorpay_payment_id;
//                 const body = {
//                     "amount": clientamount,
//                     "saving_plan_id": shemData?.id,
//                     "transaction_id": res?.razorpay_payment_id,
//                     'benificiar': benificid,
//                     "payment_method": 'razor_pay',
//                 }
//                 postSchemaSave(body, token).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     router('/user/dashboard')
//                     toast.success(`Payment successful from ${shemData?.name}`)
//                     setShowRazorpayModal(false);
//                     let resBody = {
//                         "paymentId": transactionId,
//                         "amount": clientamount
//                     }

//                     capture_payment(resBody)
//                         .then((res) => {
//                             // console.log(res)
//                         })
//                         .catch((e) => {
//                         })
//                 }).catch(err => {
//                 })
//             },

//             theme: {
//                 color: '#650020',
//             },
//         };

//         const rzpay = new Razorpay(options);

//         rzpay.open();

//         // Reset the showRazorpayModal state after payment completion

//         rzpay.on('payment.failed', function (response) {
//             setShowRazorpayModal(false);
//             console.error(response.error.description);
//             toast.error(response.error.description)
//         });

//     }, [price, shemData]);

//     // 2 plan

//     const handlePaymentDigital = useCallback(async () => {

//         const options = {
//             key: RAZAR_KEY,
//             amount: (clientamount) * 100,
//             currency: "INR",
//             name: 'Greenheap',
//             description: 'Greenheap',
//             image: "/assets/iocns/__Fav Icon.png",
//             handler: (res) => {

//                 const transactionId = res.razorpay_payment_id;

//                 const body = {
//                     "digital_plan_id": shemData?.id,
//                     "amount": clientamount,
//                     "transaction_id": res?.razorpay_payment_id,
//                     // 'benificiar': benificid,
//                     "payment_method": 'razor_pay',
//                 }
//                 Savedigitalplan(body).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     router('/user/dashboard')
//                     toast.success(`Payment successful from ${shemData?.name}`)
//                     setShowRazorpayModal(false);

//                     let resBody = {
//                         "paymentId": transactionId,
//                         "amount": clientamount
//                     }

//                     capture_payment(resBody)
//                         .then((res) => {
//                             // console.log("done")
//                         })
//                         .catch((e) => {
//                         })


//                 }).catch(err => {
//                 })


//             },
//             theme: {
//                 color: '#650020',
//             },
//         };

//         const rzpay = new Razorpay(options);

//         rzpay.open();

//         // Reset the showRazorpayModal state after payment completion
//         rzpay.on('payment.failed', function (response) {
//             setShowRazorpayModal(false);
//             console.error(response.error.description);
//             toast.error(response.error.description)
//         });

//     }, [price, shemData]);

//     //-- silver plan --//

//     const handlePaymentDigitalSilver = useCallback(async () => {

//         const options = {
//             key: RAZAR_KEY,
//             amount: (clientamount) * 100,
//             currency: "INR",
//             name: 'Greenheap',
//             description: 'Greenheap',
//             image: "/assets/iocns/__Fav Icon.png",
//             handler: (res) => {

//                 const transactionId = res.razorpay_payment_id;

//                 const body = {
//                     "digital_plan_id": shemData?.id,
//                     "amount": clientamount,
//                     "transaction_id": res?.razorpay_payment_id,
//                     // 'benificiar': benificid,
//                     "payment_method": 'razor_pay',
//                 }
//                 SavedigitalSilverplan(body).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     router('/user/dashboard')
//                     toast.success(`Payment successful from ${shemData?.name}`)
//                     setShowRazorpayModal(false);

//                     let resBody = {
//                         "paymentId": transactionId,
//                         "amount": clientamount
//                     }

//                     capture_payment(resBody)
//                         .then((res) => {
//                             // console.log("done")
//                         })
//                         .catch((e) => {
//                         })


//                 }).catch(err => {
//                 })


//             },
//             theme: {
//                 color: '#650020',
//             },
//         };

//         const rzpay = new Razorpay(options);

//         rzpay.open();

//         // Reset the showRazorpayModal state after payment completion
//         rzpay.on('payment.failed', function (response) {
//             setShowRazorpayModal(false);
//             console.error(response.error.description);
//             toast.error(response.error.description)
//         });

//     }, [price, shemData]);
//     //--//
//     // 3 plan
//     const handlePaymentgoldplant = useCallback(async () => {
//         const options = {
//             key: RAZAR_KEY,
//             amount: (ChargeAmt) * 100,
//             currency: "INR",
//             name: 'Greenheap',
//             description: 'Greenheap',
//             image: "/assets/iocns/__Fav Icon.png",
//             handler: (res) => {

//                 const transactionId = res.razorpay_payment_id;
//                 const clientamount = ChargeAmt

//                 const body = {
//                     "gold_plant_id": shemData?.id,
//                     "amount": ChargeAmt,
//                     "transaction_id": res?.razorpay_payment_id,
//                     'benificiar': Benifitid,
//                     "payment_method": 'razor_pay',
//                 }
//                 SaveGoldplan(body).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     router('/user/dashboard')
//                     toast.success(`Payment successful from ${shemData?.name}`)
//                     setShowRazorpayModal(false);
//                     setbenificid()


//                     let resBody = {
//                         "paymentId": transactionId,
//                         "amount": clientamount
//                     }

//                     capture_payment(resBody)
//                         .then((res) => {
//                             // console.log(res)
//                         })
//                         .catch((e) => {
//                         })


//                 }).catch(err => {
//                 })
//             },
//             theme: {
//                 color: '#650020',
//             },
//         };

//         const rzpay = new Razorpay(options);

//         rzpay.open();

//         // Reset the showRazorpayModal state after payment completion
//         rzpay.on('payment.failed', function (response) {
//             setShowRazorpayModal(false);
//             console.error(response.error.description);
//             toast.error(response.error.description)
//         });

//     }, [ChargeAmt, shemData]);

//     const [Shcudle, setShcudle] = useState([])

//     const [digita_shedule, setdigital_shedule] = useState([])
//     const [digital_silver, setDigital_silver] = useState([])
//     const [gold_shedule, setgold_shedule] = useState([])

//     const [chitPlanData, setPlanData] = useState([])



//     const handleGetSchema = () => {
//         setisLoading(true)
//         getShemesSchedule(token).then(res => {
//             setShcudle(res);
//             setPlanData(res?.data)

//             setisLoading(false)
//         }).catch(err => {
//             setisLoading(false)
//         })
//     }

//     const handleDigitalSchmea = () => {
//         Getdigital_trans()
//             .then((res) => {
//                 setdigital_shedule(res)

//                 setisLoading(false)
//             })
//             .catch((err) => {
//                 setisLoading(false)
//             })
//     }

//     const handleDigitalSilver = () => {
//         Getdigital_silver_trans()
//             .then((res) => {
//                 setDigital_silver(res)
//                 setisLoading(false)
//             })
//             .catch((err) => {
//                 setisLoading(false)
//             })
//     }

//     const handleGoldGetSchema = () => {
//         setisLoading(true)
//         GetGoldPlantApi(token).then(res => {
//             setgold_shedule(res)
//             setisLoading(false)
//         }).catch(err => {
//             setisLoading(false)
//         })
//     }



//     const handlepayModal = () => {
//         if (shemData?.plan_title === "saving_plan") {
//             handlePayment()
//         }
//         if (shemData?.plan_title === "digital_plan") {
//             handlePaymentDigital()
//         }
//         if (shemData?.plan_title === "digital_silver_plan") {
//             handlePaymentDigitalSilver()
//         }
//         if (shemData?.plan_title === "gold_plant") {
//             handlePaymentgoldplant();
//         }
//     }
//     useEffect(() => {
//         if (token) {
//             handleGetSchema();
//             // handleDigitalSchmea();
//             // handleGoldGetSchema();
//             // handleDigitalSilver();
//         }
//     }, [token]);

//     useEffect(() => {
//         const autoOpen = localStorage.getItem("autoOpenSchemePopup");
//         const pendingScheme = localStorage.getItem("pendingScheme");
//         if (autoOpen === "true" && !isLoading && pendingScheme) {
//             localStorage.removeItem("autoOpenSchemePopup");
//             localStorage.removeItem("pendingScheme");
//             try {
//                 const scheme = JSON.parse(pendingScheme);
//                 setSchemaData(scheme);
//                 setTimeout(() => {
//                     const btn = document.getElementById('openPriceplanpopu');
//                     if (btn) {
//                         btn.click();
//                         if (document.getElementById('agreecheck')) {
//                             document.getElementById('agreecheck').checked = false;
//                         }
//                         setchecked(false);
//                     }
//                 }, 200);
//             } catch (e) {
//                 console.error("Error parsing pendingScheme", e);
//             }
//         }
//     }, [isLoading]);



//     useEffect(() => {
//         AOS.init({
//             duration: 1500
//         });
//     }, []);

//     const getscheme_plans = () => {
//         schemeplans(detail_info?.id ? detail_info?.id : '')
//             .then((res) => {
//                 setscheme_list(res?.data[0])
//                 setDegitalScheme(res?.data[1])
//                 setGoldplant_data(res?.data[2])
//                 setDigitalSilverPlan(res?.data[3])
//                 setisLoading(false)
//                 setschemelist(res?.data)
//             })
//             .catch((err) => {
//                 setisLoading(false)
//             })
//     }


//     useEffect(() => {
//         getscheme_plans()
//     }, [detail_info?.id])



//     const paymentfun = (e) => {
//         e.preventDefault()

//         if (process_type == '1') {
//             setShowRazorpayModal(true);
//             handlepayModal();
//             document.getElementById('payment-pup').click()
//             document.getElementById('Rupees').value = null
//         }
//         else if (process_type == '2') {
//             document.getElementById('payment-pup').click()
//             document.getElementById('offlinepop-pup').click()
//             document.getElementById('transaction-id').value = null
//             setfile1()
//             settransfile()
//             setTranscationid()
//         }
//         else if (process_type == '3') {
//             document.getElementById('payment-pup').click()
//             document.getElementById('bankpop-pup').click()
//             document.getElementById('transaction-id2').value = null
//             setTranscationid()
//         }
//         else {
//             toast.error('please select payment method')
//         }

//     }

//     const upimethod = (e) => {
//         e.preventDefault()

//         if (!transfile) {
//             toast.error('please Upload the transaction slip');
//             return false;
//         }

//         if (shemData?.plan_title === 'saving_plan') {

//             if (Transactionid || transfile) {

//                 setspinner(true)

//                 const formdata = new FormData()
//                 formdata.append('amount', clientamount)
//                 formdata.append('saving_plan_id', shemData?.id)
//                 formdata.append('transaction_id', Transactionid ? Transactionid : null)
//                 formdata.append('benificiar', benificid)
//                 formdata.append('payment_method', 'upi')
//                 formdata.append('uploads', transfile)

//                 postSchemaSave(formdata).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     setspinner(false)
//                     // toast.success(`Payment successful from ${shemData?.name}`)
//                     toast.success('Transaction submitted successfully. Please wait for admin approval')

//                     document.getElementById('offlinepop-pup').click()
//                     router('/user/dashboard')

//                     setShowRazorpayModal(false);
//                 }).catch(err => {
//                 })


//             }
//             else {
//                 toast.error('please Upload the transaction slip or enter the transaction ID')
//             }
//         }

//         if (shemData?.plan_title === "digital_plan") {

//             if (Transactionid || transfile) {

//                 setspinner(true)
//                 const formdata = new FormData()
//                 formdata.append('amount', clientamount)
//                 formdata.append('digital_plan_id', shemData?.id)
//                 formdata.append('transaction_id', Transactionid ? Transactionid : null)
//                 formdata.append('benificiar', benificid)
//                 formdata.append('payment_method', 'upi')
//                 formdata.append('uploads', transfile)

//                 Savedigitalplan(formdata).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     // toast.success(`Payment successful from ${shemData?.name}`)
//                     toast.success('Transaction submitted successfully. Please wait for admin approval')

//                     document.getElementById('offlinepop-pup').click()
//                     router('/user/dashboard')


//                     setShowRazorpayModal(false);
//                     setspinner(false)
//                 }).catch(err => {
//                 })


//             }
//             else {
//                 toast.error('please Upload the transaction slip or enter the transaction ID')
//             }
//         }

//         if (shemData?.plan_title === "digital_silver_plan") {

//             if (Transactionid || transfile) {

//                 setspinner(true)
//                 const formdata = new FormData()
//                 formdata.append('amount', clientamount)
//                 formdata.append('digital_plan_id', shemData?.id)
//                 formdata.append('transaction_id', Transactionid ? Transactionid : null)
//                 formdata.append('benificiar', benificid)
//                 formdata.append('payment_method', 'upi')
//                 formdata.append('uploads', transfile)

//                 SavedigitalSilverplan(formdata).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     // toast.success(`Payment successful from ${shemData?.name}`)
//                     toast.success('Transaction submitted successfully. Please wait for admin approval')

//                     document.getElementById('offlinepop-pup').click()
//                     router('/user/dashboard')


//                     setShowRazorpayModal(false);
//                     setspinner(false)
//                 }).catch(err => {
//                 })


//             }
//             else {
//                 toast.error('please Upload the transaction slip or enter the transaction ID')
//             }
//         }

//         if (shemData?.plan_title === "gold_plant") {

//             if (Transactionid || transfile) {

//                 setspinner(true)

//                 const formdata = new FormData()
//                 formdata.append('amount', clientamount)
//                 formdata.append('gold_plant_id', shemData?.id)
//                 formdata.append('transaction_id', Transactionid ? Transactionid : null)
//                 formdata.append('benificiar', benificid)
//                 formdata.append('payment_method', 'upi')
//                 formdata.append('uploads', transfile)

//                 SaveGoldplan(formdata).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     // toast.success(`Payment successful from ${shemData?.name}`)
//                     toast.success('Transaction submitted successfully. Please wait for admin approval')

//                     document.getElementById('offlinepop-pup').click()
//                     router('/user/dashboard')


//                     setShowRazorpayModal(false);
//                     setspinner(false)
//                 }).catch(err => {
//                 })


//             }
//             else {
//                 toast.error('please Upload the transaction slip or enter the transaction ID')
//             }
//         }

//     }

//     const Bankmethod = (e) => {
//         e.preventDefault()

//         if (!transfile) {
//             toast.error('please Upload the transaction slip');
//             return false;
//         }

//         if (shemData?.plan_title === 'saving_plan') {

//             if (Transactionid || transfile) {

//                 setspinner(true)

//                 const formdata = new FormData()
//                 formdata.append('amount', clientamount)
//                 formdata.append('saving_plan_id', shemData?.id)
//                 formdata.append('transaction_id', Transactionid ? Transactionid : null)
//                 formdata.append('benificiar', benificid)
//                 formdata.append('payment_method', 'bank')
//                 formdata.append('uploads', transfile)

//                 postSchemaSave(formdata).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     // toast.success(`Payment successful from ${shemData?.name}`)
//                     // toast.success('Transaction submitted successfully. Please wait for admin approval')

//                     document.getElementById('bankpop-pup').click()
//                     router('/user/dashboard')
//                     setShowRazorpayModal(false);
//                     setspinner(false)
//                 }).catch(err => {
//                 })
//             }
//             else {
//                 toast.error('please Upload the transaction slip or enter the transaction ID')
//             }
//         }
//         if (shemData?.plan_title === "digital_plan") {

//             if (Transactionid || transfile) {

//                 setspinner(true)

//                 const formdata = new FormData()
//                 formdata.append('amount', clientamount)
//                 formdata.append('digital_plan_id', shemData?.id)
//                 formdata.append('transaction_id', Transactionid ? Transactionid : null)
//                 formdata.append('benificiar', benificid)
//                 formdata.append('payment_method', 'bank')
//                 formdata.append('uploads', transfile)

//                 Savedigitalplan(formdata).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     // toast.success(`Payment successful from ${shemData?.name}`)
//                     toast.success('Transaction submitted successfully. Please wait for admin approval')

//                     document.getElementById('bankpop-pup').click()
//                     router('/user/dashboard')
//                     setShowRazorpayModal(false);
//                     setspinner(false)
//                 }).catch(err => {
//                 })


//             }
//             else {
//                 toast.error('please Upload the transaction slip or enter the transaction ID')
//             }
//         }
//         if (shemData?.plan_title === "digital_silver_plan") {

//             if (Transactionid || transfile) {

//                 setspinner(true)

//                 const formdata = new FormData()
//                 formdata.append('amount', clientamount)
//                 formdata.append('digital_plan_id', shemData?.id)
//                 formdata.append('transaction_id', Transactionid ? Transactionid : null)
//                 formdata.append('benificiar', benificid)
//                 formdata.append('payment_method', 'bank')
//                 formdata.append('uploads', transfile)

//                 SavedigitalSilverplan(formdata).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     // toast.success(`Payment successful from ${shemData?.name}`)
//                     toast.success('Transaction submitted successfully. Please wait for admin approval')

//                     document.getElementById('bankpop-pup').click()
//                     router('/user/dashboard')
//                     setShowRazorpayModal(false);
//                     setspinner(false)
//                 }).catch(err => {
//                 })


//             }
//             else {
//                 toast.error('please Upload the transaction slip or enter the transaction ID')
//             }
//         }
//         if (shemData?.plan_title === "gold_plant") {

//             if (Transactionid || transfile) {

//                 setspinner(true)
//                 const formdata = new FormData()
//                 formdata.append('amount', clientamount)
//                 formdata.append('gold_plant_id', shemData?.id)
//                 formdata.append('transaction_id', Transactionid ? Transactionid : null)
//                 formdata.append('benificiar', benificid)
//                 formdata.append('payment_method', 'bank')
//                 formdata.append('uploads', transfile)

//                 SaveGoldplan(formdata).then(res => {
//                     if (res?.error) {
//                         return toast.error(res?.error ?? 'Somthing Went Wrong!')
//                     }
//                     // toast.success(`Payment successful from ${shemData?.name}`)
//                     // toast.success('Transaction submitted successfully. Please wait for admin approval')
//                     document.getElementById('bankpop-pup').click()
//                     router('/user/dashboard')
//                     setShowRazorpayModal(false);

//                     setspinner(false)
//                 }).catch(err => {
//                 })


//             }
//             else {
//                 toast.error('please Upload the transaction slip or enter the transaction ID')
//             }
//         }

//     }

//     const screenshot = (e) => {
//         setfile1(e.target.files[0]?.name)
//         settransfile(e.target.files[0])
//     }


//     const getenroll = () => {
//         Enroll_fun()
//             .then((res) => {
//                 setEnroll_data(res?.data)
//                 setisLoading(false)
//             })
//             .catch((err) => {
//                 setisLoading(false)
//             })
//     }

//     useEffect(() => {
//         getenroll()
//     }, [])



//     //added 

//     const upiId = "Vyapar.171813426519@hdfcbank";
//     const phonumber = setting_data ? setting_data[0]?.phone : "8190059995"
//     // const rawPhone = setting_data ? setting_data[0]?.phone : "8190059995";

//     // const phonumber = rawPhone.replace(/^\+\d+\s*/, "").replace(/\D/g, "");

//     const [openSnackbar, setOpenSnackbar] = useState(false);

//     const [copiedField, setCopiedField] = useState("");

//     const handleCopy = (text, fieldKey) => {
//         navigator.clipboard
//             .writeText(text)
//             .then(() => {
//                 setCopiedField(fieldKey); // mark this field as copied
//                 // toast.success("Copied"); // show toast
//                 setTimeout(() => setCopiedField(""), 2000);
//                 setOpenSnackbar(true); /// reset after 2s
//             })
//             .catch((err) => console.error("Copy failed:", err));
//     };

//     const handleCloseSnackbar = (_, reason) => {
//         if (reason === "clickaway") return;
//         setOpenSnackbar(false);
//     };
//     const [showModal, setShowModal] = useState(false);
//     const handleOpen = () => setShowModal(true);
//     const handleClose = () => setShowModal(false);
//     const [previewUrl, setPreviewUrl] = useState(null);


//     const PlanCard = ({ plan, route }) => {
//         if (!plan) return null;
//         return (
//             // <div className="card h-100 shadow-sm border-1 " data-aos="zoom-in">
//             //     <div className="card-body d-flex flex-column justify-content-between">
//             //         <h5 className="fw-bold mb-3">{plan.name}</h5>
//             //         <p className="mb-1 text-muted">
//             //             Min Amount: <strong>₹{Number(plan.min_price).toLocaleString("en-IN")}</strong>
//             //         </p>
//             //         <p className="mb-3 text-muted">
//             //             Max Amount: <strong>₹{Number(plan.max_price).toLocaleString("en-IN")}</strong>

//             //         </p>
//             //         <button className="btn w-100" style={{ backgroundColor: "#650020", color: "white" }} onClick={() => router(route)}>
//             //             Pay Now
//             //         </button>
//             //     </div>

//             // </div>
//             <div
//                 className="card h-100 shadow-sm border-1 rounded-4 p-3"
//                 data-aos="zoom-in"
//             //   style={ cursor: "pointer" }

//             >
//                 <div className="card-body d-flex flex-column justify-content-between text-center">

//                     {/* Row 1: Name, Withdraw, Weight */}
//                     <div className="d-flex justify-content-between mb-3 align-items-center">
//                         {/* Name */}
//                         <div className="text-start flex-grow-1 me-2" style={{ minWidth: 0 }}>
//                             <span className="text-muted small d-block">Name</span>
//                             <p
//                                 className="fw-semibold text-success mb-0"
//                                 style={{
//                                     overflow: "hidden",
//                                     whiteSpace: "nowrap",
//                                     textOverflow: "ellipsis",
//                                 }}
//                                 title={plan?.users?.name || ""}
//                             >
//                                 {plan?.users?.name || "-"}
//                             </p>
//                         </div>

//                         {/* Withdraw */}
//                         {/* <div className="text-center flex-shrink-0 me-2" style={{ width: "80px" }}>
//         <span className="text-muted small d-block">Withdraw</span>
//         <p className="fw-semibold text-success mb-0">
//           {plan?.withdraw != null ? plan?.withdraw : "-"}
//         </p>
//       </div> */}

//                         {/* Weight */}
//                         <div className="text-center flex-shrink-0" style={{ width: "80px" }}>
//                             <span className="text-muted small d-block">Weight</span>
//                             <p className="fw-semibold text-success mb-0">
//                                 {plan?.purchase_transaction?.[0]?.gold_gram
//                                     ? Number(plan?.purchase_transaction[0]?.gold_gram).toLocaleString("en-IN")
//                                     : "-"} g
//                             </p>
//                         </div>
//                     </div>

//                     {/* Row 2: Amount, Withdraw Date */}
//                     <div className="d-flex justify-content-between mb-4 align-items-center">
//                         {/* Amount */}
//                         <div className="text-start flex-grow-1 me-2" style={{ minWidth: 0 }}>
//                             <span className="text-muted small d-block">Amount</span>
//                             <p className="fw-semibold text-success mb-0">
//                                 ₹{Number(plan?.amount || 0).toLocaleString("en-IN")}
//                             </p>
//                         </div>

//                         <div className="text-center flex-shrink-0 me-2" style={{ width: "80px" }}>
//                             <span className="text-muted small d-block">Withdraw</span>
//                             <p className="fw-semibold text-success mb-0">
//                                 {plan?.withdraw != null ? plan?.withdraw : "-"}
//                             </p>
//                         </div>

//                     </div>
//                     <div className="mb-2 text-center">
//                         <span
//                             className="badge fs-6"
//                             style={{ backgroundColor: "#ffe6ec", color: "#650020" }}
//                         >
//                             2 Months Bonus
//                         </span>
//                     </div>
//                     {/* Action Button */}
//                     <button
//                         className="btn w-100 rounded-pill fw-semibold"
//                         style={{ backgroundColor: "#650020", color: "white" }}
//                         onClick={() => router(route)}
//                     >
//                         Pay Now
//                     </button>
//                 </div>
//             </div>


//             //         <div
//             //             className="card h-100 shadow-sm border-1 rounded-4"
//             //             data-aos="zoom-in"
//             //         >
//             //             <div className="card-body d-flex flex-column justify-content-between text-center">

//             //                 {/* Plan Name */}
//             //                 {/* <h5 className="fw-bold mb-3 text-dark">
//             //   {plan?.saving_plan?.name}
//             // </h5> */}

//             //                 <div className="d-flex justify-content-between">

//             //                     <div className="mb-2">
//             //                         <span className="text-muted small">Name</span>
//             //                         <p className="fw-small text-success mb-0">
//             //                             {plan?.users?.name}
//             //                         </p>
//             //                     </div>



//             //                     <div className="mb-4">
//             //                         <span className="text-muted small">Withdraw</span>
//             //                         <p className="fw-small mb-0">
//             //                             {plan?.withdraw_date != null ? plan?.withdraw_date
//             //                                 : "-"}
//             //                         </p>
//             //                     </div>
//             //                 </div>

//             //                 <div className="d-flex justify-content-between">



//             //                     <div className="mb-2">
//             //                         <span className="text-muted small">Amount</span>
//             //                         <p className="fw-small text-success mb-0">
//             //                             ₹{Number(plan?.amount).toLocaleString("en-IN")}
//             //                         </p>
//             //                     </div>


//             //                     <div className="mb-2">
//             //                         <span className="text-muted small">Weight</span>
//             //                         <p className="fw-small text-success mb-0">
//             //                             {plan?.purchase_transaction[0]?.gold_gram ? Number(plan?.purchase_transaction[0]?.gold_gram).toLocaleString("en-IN") : "-"}
//             //                         </p>
//             //                     </div>


//             //                     <div className="mb-4">
//             //                         <span className="text-muted small">Withdraw Date</span>
//             //                         <p className="fw-small mb-0">
//             // {plan?.withdraw_date != null ? plan?.withdraw_date
//             //     : "-"}
//             //                         </p>
//             //                     </div>
//             //                 </div>

//             //                 <button
//             //                     className="btn w-100 rounded-pill fw-semibold"
//             //                     style={{ backgroundColor: "#650020", color: "white" }}
//             //                     onClick={() => router(route)}
//             //                 >
//             //                     Details
//             //                 </button>
//             //             </div>
//             //         </div>

//         );
//     };

//     const isAnyActive =
//         (Shcudle?.active_count > 0) && chitPlanData?.length > 0;
//     // (digita_shedule?.active_count > 0) ||
//     // (digital_silver?.active_count > 0) ||
//     // (gold_shedule?.active_count > 0);




//     return (<>
//         <section>
//             <button type="button" className="d-none" data-bs-toggle="modal" id='openPriceplanpopu' data-bs-target="#razarpaypopup"> sssdsdsd</button>

//             <div className="modal fade" id="razarpaypopup" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="razarpaypopupLabel" aria-hidden="true">
//                 <div className="modal-dialog modal-dialog-centered">
//                     <div className={shemData?.plan_title === "gold_plant" ? 'modal-content paybox schemecard' : 'modal-content schemecard'}>
//                         <div className="modal-header">
//                             <h1 className="modal-title fs-5 schemename" id="razarpaypopupLabel">{shemData?.plan_title === "digital_plan" ? `${shemData?.name}(Cash Back)` : shemData?.plan_title === "gold_plant" ? `${shemData?.name}(Monthly Rental)` : shemData?.name}</h1>

//                             <button type="button" className="btn-close" id='closepriceModal' data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('Rupees').value = null; setprice(null) }} ></button>
//                         </div>
//                         <div className="modal-body">
//                             <form ref={fromsubmit} onSubmit={(e) => {
//                                 e.preventDefault();

//                                 if (!price) {
//                                     toast.error("Please Enter Price!")
//                                 } else if (shemData?.plan_title === "gold_plant") {
//                                     const amount = parseFloat(price) + parseFloat(((price * 6 / 100) + (price * 3 / 100)))

//                                     if (parseInt(price) < parseInt(shemData?.min_price)) {
//                                         toast.error(`Minmum Amount is ${shemData?.min_price}!`)
//                                     } else if (parseInt(price) > shemData?.max_price) {
//                                         toast.error(`Maximum Amount is ${shemData?.max_price}!`)
//                                     } else if (checked !== true) {
//                                         toast.error('Please Agree Terms & conditions')
//                                     }
//                                     else {
//                                         document.getElementById('closepriceModal')?.click();
//                                         document.getElementById('payment-pup').click()
//                                         document.getElementById('inlineRadio1').checked = false;
//                                         document.getElementById('inlineRadio2').checked = false;
//                                         document.getElementById('inlineRadio3').checked = false;
//                                         document.getElementById('Rupees').value = null
//                                         setprocess_type();
//                                         setclientamount(price)
//                                         setChargeAmt(amount)
//                                         setBenifitid(benificid)

//                                     }
//                                 } else {
//                                     if (parseInt(price) < parseInt(shemData?.min_price)) {
//                                         toast.error(`Minmum Amount is ${shemData?.min_price}!`)
//                                     } else if (parseInt(price) > shemData?.max_price) {
//                                         toast.error(`Maximum Amount is ${shemData?.max_price}!`)
//                                     } else if (checked !== true) {
//                                         toast.error('Please Agree Terms & conditions')
//                                     }
//                                     else {
//                                         document.getElementById('closepriceModal')?.click();
//                                         document.getElementById('payment-pup').click()
//                                         document.getElementById('inlineRadio1').checked = false;
//                                         document.getElementById('inlineRadio2').checked = false;
//                                         document.getElementById('inlineRadio3').checked = false;
//                                         setprocess_type();
//                                         setclientamount(price)

//                                     }
//                                 }

//                             }}>

//                                 {/* {
//                                     shemData?.plan_title === "digital_plan" ? '' : (
//                                         <div className="mb-3" style={{overflow:"hidden"}}>
//                                             <label className="col-form-label fw-bold">Beneficiaries</label>
//                                             <select className="form-select " onChange={(e) => { setbenificid(e.target.value) }} aria-label="ben" >
//                                                 <option value={''} >{detail_info?.name}</option>
//                                                 {
//                                                     benfic.map((data, i) => (
//                                                         <option value={data?.id} key={i}>{data.name}</option>
//                                                     ))
//                                                 }
//                                             </select>
//                                         </div>
//                                     )
//                                 } */}


//                                 {shemData?.plan_title !== "digital_plan" && (
//                                     <div className="mb-3">
//                                         <label className="col-form-label fw-bold">Beneficiaries</label>
//                                         <Select
//                                             options={[
//                                                 { value: '', label: detail_info?.name },
//                                                 ...benfic.map(b => ({ value: b.id, label: b.name }))
//                                             ]}
//                                             defaultValue={{ value: '', label: detail_info?.name }}
//                                             onChange={(selected) => setbenificid(selected.value)}
//                                             menuPortalTarget={document.body} // ensures dropdown is on top
//                                             styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
//                                         />
//                                     </div>
//                                 )}


//                                 <div className="mb-3">
//                                     <label htmlFor="Rupees" className="form-label"><span className='fw-bold'>Price</span> <small className='text-danger'>{`(Minimum Amount ${shemData?.min_price} to Maximum Amount ${shemData?.max_price})`}</small></label>
//                                     <input type="text" maxLength={10} value={price} onChange={(e) => setprice(e.target.value?.replace(/[^0-9]/g, ""))} className="form-control p-3" id="Rupees" placeholder={`Ex: ${shemData?.min_price}`} />
//                                     {/* {shemData?.plan_title === "gold_plant" && price ? <span className='text-color'>Deduct Gst & Service tax  : {(price - ((price * 6 / 100) + (price * 3 / 100))).toFixed(2)}</span> : ''} */}
//                                     {shemData?.plan_title === "gold_plant" ? (<><p className='text-color m-0'>VAT charge : {price ? (price * 3 / 100).toFixed(2) : 0}</p>
//                                         <p className='text-color m-0'>Service charge : {price ? (price * 6 / 100).toFixed(2) : 0}</p>
//                                         <p className='text-color m-0'>VAT + Service  : {price ? ((price * 6 / 100) + (price * 3 / 100)).toFixed(2) : 0}</p>
//                                         <p className='text-color m-0'>Total Amount   : {price ? (parseFloat(price) + ((price * 6 / 100) + (price * 3 / 100))) : 0}</p>
//                                     </>) : ''}
//                                 </div>
//                                 <div className="mb-3">
//                                     <input className="form-check-input" type="checkbox" value="" id="agreecheck" onChange={(e) => { setchecked(e.target.checked) }} />

//                                     <label className="form-check-label ms-2" htmlFor="flexCheckDefault">
//                                         {/* I  agree {
//                                             footerpage ? (<a href={`pages/${footerpage[0]?.slug}`} target='_blank'><span className='termsborder'>Terms and Condition</span></a>) : (<span className='termsborder'>Terms and Condition</span>)
//                                         } */}
//                                         I agree <a href={`pages/${shemData?.page?.slug}`} target='_blank'><span className='termsborder'>Terms and Condition</span></a>
//                                     </label>
//                                 </div>

//                                 <div className="mb-3">
//                                     <div className="update-profile  mx-2">
//                                         <button className="text-white" type="submit">Continue</button>
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//             {isAnyActive && token && (
//                 <div className='px-5'>
//                     <div className='d-flex justify-content-center w-100 text-center titsksd mb-3'>
//                         <div>
//                             <div data-aos="fade-right">
//                                 <img src='/assets/images/shpas.png' />
//                             </div>
//                             <div data-aos="fade-left">
//                                 <h2 className='fw-bold'>Chit Scheme Active Plans</h2>
//                             </div>
//                         </div>
//                     </div>
//                     {chitPlanData?.length > 5 && token ? (
//                         <Swiper
//                             modules={[Autoplay]}
//                             spaceBetween={16}
//                             slidesPerView={4}
//                             autoplay={{
//                                 delay: 2500,
//                                 disableOnInteraction: false,
//                             }}
//                             loop={chitPlanData?.length >= 8}
//                             className="plan-swiper"
//                             breakpoints={{
//                                 0: { slidesPerView: 1.2 },
//                                 576: { slidesPerView: 2 },
//                                 768: { slidesPerView: 3 },
//                                 992: { slidesPerView: 4 },
//                             }}
//                         >
//                             {chitPlanData.map((chit) => (
//                                 <SwiperSlide key={chit.id}>
//                                     <PlanCard
//                                         plan={chit}
//                                         route="/user/chit-jewels"
//                                     />
//                                 </SwiperSlide>
//                             ))}
//                         </Swiper>
//                     ) : (
//                         <div className="row g-4 my-2 justify-content-center">
//                             {chitPlanData.map((chit) => (
//                                 <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3" key={chit.id}>
//                                     <PlanCard
//                                         plan={chit}
//                                         route="/user/chit-jewels"
//                                     />
//                                 </div>
//                             ))}
//                         </div>
//                     )}



//                 </div>
//             )}






//             <div className='px-5'>
//                 <div className='d-flex justify-content-center w-100 text-center titsksd mb-3'>
//                     <div>
//                         <div data-aos="fade-right">
//                             <img src='/assets/images/shpas.png' />
//                         </div>
//                         <div data-aos="fade-left">
//                             <h2 className='fw-bold'>Quick overview of schemes</h2>
//                         </div>
//                     </div>
//                 </div>

//                 {isLoading ?
//                     (<>
//                         <div className=' row  '>
//                             {
//                                 Array.from({ length: 4 }).map((_, i) => (
//                                     <div className='col-md-6  col-lg-3 col-md-6 col-sm-12 mt-lg-0 mt-sm-3' key={i}>
//                                         <div className='d-sm-flex justify-content-sm-center d-md-block  justify-content-md-center d-none d-sm-block '>
//                                             <div className='schema_main  '>
//                                                 <div className='top'>

//                                                     <img alt='' src='/assets/images/Scheme 3.png' className='log mb-3' />
//                                                     <h4 className=' fw-bold pb-2'> <Shimmer width={180} height={30} /></h4>
//                                                 </div>
//                                                 <div className='schema'>
//                                                     <div className='d-flex gap-2 align-items-center mb-3'>

//                                                         <Shimmer width={250} height={22} className='rounded' />
//                                                     </div>
//                                                     <div className='d-flex gap-2 align-items-center mb-3'>

//                                                         <Shimmer width={250} height={22} className='rounded' />
//                                                     </div>
//                                                     <div className='d-flex gap-2 align-items-center mb-3'>

//                                                         <Shimmer width={250} height={22} className='rounded' />
//                                                     </div>
//                                                     <div className='d-flex gap-2 align-items-center mb-3'>

//                                                         <Shimmer width={250} height={22} className='rounded' />
//                                                     </div>
//                                                     <div className='d-flex gap-2 align-items-center mb-3 '>

//                                                         <Shimmer width={250} height={22} className='rounded' />
//                                                     </div>

//                                                     <div className='schemebtn-3'>
//                                                         <Shimmer width={177} height={49} className='rounded-5' />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))
//                             }
//                         </div>
//                         <div className='d-block d-sm-none '>
//                             {
//                                 Array.from({ length: 3 }).map((_, i) => (
//                                     <div className='my-2' key={i}>
//                                         <Shimmer className='rounded w-100' height={100} width={100} />
//                                     </div>

//                                 ))
//                             }

//                         </div>
//                     </>)
//                     :
//                     <div className='row'>
//                         {
//                             scheme_list ?
//                                 (<>
//                                     <div className='col-md-6 col-lg-3 col-sm-12 chkclick mb-3' >
//                                         <div data-aos="fade-up" className='scheme-mbbox'>
//                                             {/* <div className='schema_main'  >
//                                             <div className='top_active act1'>
//                                                 <div className='benefits_flx'>
//                                                 <img alt='' src='/assets/images/green.png' className='log' />
//                                                 <div>
//                                                     <button id="blinking-button">Benefits 25% Extra Savings</button>
//                                                 </div>
//                                                 </div>

//                                                 <h4 className=' fw-bold pb-2 mt-4'>{scheme_list?.name}</h4>
//                                             </div>
//                                             <div className='schema schemelen'>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Lock in Period </p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>{scheme_list?.plan_tenure ?? 0} Months</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Punctuality Bonus</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>{scheme_list?.punctuality_bonus ?? 0} %</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Profit Rate </p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>{scheme_list?.bonus ?? 0} %</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Minimum</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>₹ {scheme_list?.min_price ?? 0}</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Maximum</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>₹ {scheme_list?.max_price ?? 0}</p>
//                                                     </div>
//                                                 </div>


//                                             </div>
//                                             <div className='schema schemebtn-1'>
//                                                 <button type='button' onClick={() => {
//                                                     if (detail_info && token) {
//                                                         setSchemaData(scheme_list);
//                                                         setprice();
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         document.getElementById("openPriceplanpopu")?.click();
//                                                         setchecked(false)

//                                                     } else {
//                                                         setSchemaData(scheme_list);
//                                                         setprice();
//                                                         document.getElementById("loginPopupopen")?.click();
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         setchecked(false)
//                                                         setopenSchemes(true);

//                                                     }
//                                                 }} className='btn d-flex align-items-center gap-2'>Buy scheme <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                 </button>



//                                                 <div className='details'>
//                                                     { token && detail_info ?
//                                                     <span onClick={() => router(`/scheme-detail/${scheme_list.plan_title}`)} className='btn'>
//                                                         Scheme Details
//                                                     </span>
//                                                      : ''}
//                                                 </div>

//                                             </div>
//                                         </div> */}
//                                             <div className='quick_img'>
//                                                 <div className='plan_img'>
//                                                     <img alt='' src={scheme_list?.frontend_banner || '/assets/images/chit_saving_plan.png'} className='log' />
//                                                 </div>
//                                                 <div className='schema schemebtn-1 '>
//                                                     <button type='button' onClick={() => {
//                                                         if (detail_info && token) {
//                                                             setSchemaData(scheme_list);
//                                                             setprice();
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("openPriceplanpopu")?.click();
//                                                             setchecked(false)

//                                                         } else {
//                                                             setSchemaData(scheme_list);
//                                                             setprice();
//                                                             document.getElementById("loginPopupopen")?.click();
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             setchecked(false)
//                                                             setopenSchemes(true);

//                                                         }
//                                                     }} className='btn d-flex align-items-center gap-2'>Buy scheme <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                     </button>



//                                                     <div className='details'>
//                                                         {token && detail_info ?
//                                                             <span onClick={() => router(`/scheme-detail/${scheme_list.plan_title}`)} className='btn'>
//                                                                 Scheme Details
//                                                             </span>
//                                                             : ''}
//                                                     </div>

//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>


//                                     {/* mobile-view */}

//                                     {/* <div className='d-block mb-scheme-box  d-sm-none my-2'>
//                                     <div className="accordion accordion-flush" id="accordionFlushExample">
//                                         <div className="accordion-item mb-schem">
//                                             <h2 className="accordion-header mb-schem-head" id="flush-headingOne">
//                                                 <div className="accordion-button collapsed d-block" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
//                                                     <div className='mb-sch-img'>
//                                                         <img alt='' src='/assets/images/green.png' className='log' />
//                                                     </div>
//                                                     <div className='mb-sch-name d-flex align-items-center justify-content-between'>
//                                                         <h5 className=' fw-bold pb-2'>{scheme_list?.name}</h5>
//                                                         <h6><ChevronDown /></h6>
//                                                     </div>
//                                                 </div>
//                                             </h2>
//                                             <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
//                                                 <div className='schema schemelen'>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Lock in Period </p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>{scheme_list?.plan_tenure ?? 0} Months</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Punctuality Bonus</p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>{scheme_list?.punctuality_bonus ?? 0} %</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Profit Rate </p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>{scheme_list?.bonus ?? 0} %</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Minimum</p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>₹ {scheme_list?.min_price ?? 0}</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Maximum</p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>₹ {scheme_list?.max_price ?? 0}</p>
//                                                         </div>
//                                                     </div>


//                                                 </div>
//                                                 <div className='schema schemebtn-1'>
//                                                     <button type='button' onClick={() => {
//                                                         if (detail_info && token) {
//                                                             setSchemaData(scheme_list);
//                                                             setprice();
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("openPriceplanpopu")?.click();
//                                                             setchecked(false)

//                                                         } else {
//                                                             setSchemaData(scheme_list);
//                                                             setprice();
//                                                             document.getElementById("loginPopupopen")?.click();
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             setchecked(false)
//                                                             setopenSchemes(true);

//                                                         }
//                                                     }} className='btn d-flex align-items-center gap-2'>Buy scheme <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                     </button>

//                                                     <div className='details'>
//                                                     { token && detail_info ?
//                                                     <span onClick={() => router(`/scheme-detail/${scheme_list.plan_title}`)} className='btn'>
//                                                         Scheme Details
//                                                     </span>
//                                                      : ''}
//                                                     </div>

//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div> */}
//                                 </>)
//                                 : ""
//                         }

//                         {
//                             DigitaScheme ? (
//                                 <>
//                                     <div className=' my-sm-4 my-md-0 col-md-6 col-lg-3 col-sm-12 chkclick fade-up mb-3' >
//                                         <div data-aos="fade-up" className='scheme-mbbox'>
//                                             {/* <div className='schema_main'>
//                                             <div className='top_active'>
//                                             <div className='benefits_flx'>
//                                                 <img alt='' src='/assets/images/green.png' className='log' />
//                                                 <div>
//                                                     <button id="blinking-button">Cashback Plan Silver</button>
//                                                 </div>
//                                                 </div>
//                                                 <h4 className=' fw-bold pb-2 mt-4'>{DigitaScheme?.name}</h4>
//                                             </div>
//                                             <div className='schema schemelen'>
//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Lock in Period</p>
//                                                     </div>

//                                                     <div>

//                                                         <p className='mb-0'>3 Years</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Active Plan</p>
//                                                     </div>

//                                                     <div>

//                                                         <p className='mb-0'>1 (gm)</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Minimum</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>₹ {DigitaScheme?.min_price ?? 0}</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Maximum</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>₹ {DigitaScheme?.max_price ?? 0}</p>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             <div className=' schema schemebtn-1'>
//                                                 <button type='button' onClick={() => {
//                                                     if (!detail_info && !token) {
//                                                         setSchemaData(DigitaScheme);
//                                                         setchecked(false)
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         document.getElementById("loginPopupopen")?.click();

//                                                     }
//                                                     else if (DigitaScheme?.cancel_status === 0) {
//                                                         toast.error('This Scheme already purchased')
//                                                     }
//                                                     else {
//                                                         setSchemaData(DigitaScheme);
//                                                         setchecked(false);
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         document.getElementById("openPriceplanpopu")?.click();
//                                                     }
//                                                 }}

//                                                     className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                 </button>

//                                                 <div className='details'>
//                                                     { token && detail_info ?
//                                                     <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
//                                                         Scheme Details
//                                                     </span>
//                                                      : ''}
//                                                 </div>
//                                             </div>
//                                         </div> */}
//                                             <div className='quick_img'>
//                                                 <div className='plan_img'>
//                                                     <img alt='' src={DigitaScheme?.frontend_banner || '/assets/images/digital_gold_sip.png'} className='log' />
//                                                 </div>
//                                                 <div className=' schema schemebtn-1'>
//                                                     <button type='button' onClick={() => {
//                                                         if (!detail_info && !token) {
//                                                             setSchemaData(DigitaScheme);
//                                                             setchecked(false)
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("loginPopupopen")?.click();

//                                                         }
//                                                         else if (DigitaScheme?.cancel_status === 0) {
//                                                             toast.error('This Scheme already purchased')
//                                                             router("/user/digital-gold")
//                                                         }
//                                                         else {
//                                                             setSchemaData(DigitaScheme);
//                                                             setchecked(false);
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("openPriceplanpopu")?.click();
//                                                         }
//                                                     }}

//                                                         className='btn d-flex align-items-center gap-2'> Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                     </button>

//                                                     <div className='details'>
//                                                         {token && detail_info ?
//                                                             <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
//                                                                 Scheme Details
//                                                             </span>
//                                                             : ''}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* mobile-view */}

//                                     {/* <div className='d-block mb-scheme-box  d-sm-none my-2'>
//                                     <div className="accordion accordion-flush" id="accordionFlushExample">
//                                         <div className="accordion-item  mb-schem">
//                                             <h2 className="accordion-header mb-schem-head" id="flush-headingOne">
//                                                 <div className="accordion-button collapsed d-block" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
//                                                     <div className='mb-sch-img'>
//                                                         <img alt='' src='/assets/images/green.png' className='log' />
//                                                     </div>
//                                                     <div className='mb-sch-name d-flex align-items-center justify-content-between'>
//                                                         <h5 className=' fw-bold pb-2'>{DigitaScheme?.name}</h5>
//                                                         <h6><ChevronDown /></h6>
//                                                     </div>
//                                                 </div>
//                                             </h2>
//                                             <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
//                                                 <div className='schema schemelen'>
//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Lock in Period</p>
//                                                         </div>

//                                                         <div>

//                                                             <p className='mb-0'>3 Years</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Active Plan</p>
//                                                         </div>

//                                                         <div>

//                                                             <p className='mb-0'>1 (gm)</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Minimum</p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>₹ {DigitaScheme?.min_price ?? 0}</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Maximum</p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>₹ {DigitaScheme?.max_price ?? 0}</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>

//                                                 <div className=' schema schemebtn-1'>
//                                                     <button type='button' onClick={() => {
//                                                         if (!detail_info && !token) {
//                                                             setSchemaData(DigitaScheme);
//                                                             setchecked(false)
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("loginPopupopen")?.click();

//                                                         }
//                                                         else if (DigitaScheme?.cancel_status === 0) {
//                                                             toast.error('This Scheme already purchased')
//                                                         }
//                                                         else {
//                                                             setSchemaData(DigitaScheme);
//                                                             setchecked(false);
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("openPriceplanpopu")?.click();
//                                                         }
//                                                     }}

//                                                         className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                     </button>

//                                                     <div className='details'>
//                                                         { token && detail_info ?
//                                                         <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
//                                                             Scheme Details
//                                                         </span>
//                                                         : ''}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div> */}
//                                 </>
//                             )
//                                 : ''
//                         }



//                         {
//                             Goldplant_data ? (<>
//                                 <div className='mt-md-4 mt-sm-0 mt-lg-0  d-sm-block  col-md-6 col-lg-3 col-sm-12 chkclick fade-up mb-3' >
//                                     <div data-aos="fade-up" className='scheme-mbbox'>
//                                         {/* <div className='schema_main'>
//                                         <div className='top_active'>
//                                         <div className='benefits_flx'>
//                                             <img alt='' src='/assets/images/green.png' className='log' />
//                                             <div>
//                                                 <button id="blinking-button">Monthly Yield Gold</button>
//                                             </div>
//                                             </div>
//                                             <h4 className=' fw-bold pb-2 mt-4'>{Goldplant_data?.name}</h4>
//                                         </div>
//                                         <div className='schema schemelen'>
//                                             <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                 <div className="d-flex gap-2  align-items-center">
//                                                     <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                     <p className='mb-0'>Principal Returns    After</p>
//                                                 </div>

//                                                 <div>
//                                                     <p className='mb-0'>{Goldplant_data?.returns_year ?? 0} year</p>
//                                                 </div>
//                                             </div>

//                                             <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                 <div className="d-flex gap-2  align-items-center">
//                                                     <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                     <p className='mb-0'>Assured Returns</p>
//                                                 </div>

//                                                 <div>
//                                                     <p className='mb-0'>{Goldplant_data?.payout_term ?? 0} year</p>
//                                                 </div>
//                                             </div>

//                                             <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                 <div className="d-flex gap-2  align-items-center">
//                                                     <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                     <p className='mb-0'>Minimum</p>
//                                                 </div>

//                                                 <div>
//                                                     <p className='mb-0'>₹ {Goldplant_data?.min_price ?? 0}</p>
//                                                 </div>
//                                             </div>

//                                             <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                 <div className="d-flex gap-2  align-items-center">
//                                                     <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                     <p className='mb-0'>Maximum</p>
//                                                 </div>

//                                                 <div>
//                                                     <p className='mb-0'>₹ {Goldplant_data?.max_price ?? 0}</p>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className=' schema schemebtn-1'>
//                                             <button type='button' onClick={() => {
//                                                 if (detail_info && token) {
//                                                     setSchemaData(Goldplant_data);
//                                                     document.getElementById('agreecheck').checked = false;
//                                                     setchecked(false)
//                                                     document.getElementById("openPriceplanpopu")?.click();
//                                                 } else {
//                                                     setSchemaData(Goldplant_data);
//                                                     document.getElementById('agreecheck').checked = false;
//                                                     setchecked(false)
//                                                     document.getElementById("loginPopupopen")?.click();
//                                                     setopenSchemes(true);
//                                                 }
//                                             }} className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                             </button>

//                                             <div className='details'>
//                                                     { token && detail_info ?
//                                                     <span onClick={() => router(`/scheme-detail/${Goldplant_data.plan_title}`)} className='btn'>
//                                                         Scheme Details
//                                                     </span>
//                                                      : ''}
//                                             </div>
//                                         </div>
//                                     </div> */}
//                                         <div className='quick_img'>
//                                             <div className='plan_img'>
//                                                 <img alt='' src={Goldplant_data?.frontend_banner || '/assets/images/gold_plant_scheme.png'} className='log' />
//                                             </div>
//                                             <div className=' schema schemebtn-1'>
//                                                 <button type='button' onClick={() => {
//                                                     if (detail_info && token) {
//                                                         setSchemaData(Goldplant_data);
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         setchecked(false)
//                                                         document.getElementById("openPriceplanpopu")?.click();
//                                                     } else {
//                                                         setSchemaData(Goldplant_data);
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         setchecked(false)
//                                                         document.getElementById("loginPopupopen")?.click();
//                                                         setopenSchemes(true);
//                                                     }


//                                                 }} className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                 </button>

//                                                 <div className='details'>
//                                                     {token && detail_info ?
//                                                         <span onClick={() => router(`/scheme-detail/${Goldplant_data.plan_title}`)} className='btn'>
//                                                             Scheme Details
//                                                         </span>
//                                                         : ''}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* mobile-view */}

//                                 {/* <div className='d-block mb-scheme-box  d-sm-none my-2'>
//                                 <div className="accordion accordion-flush" id="accordionFlushExample">
//                                     <div className="accordion-item mb-schem">
//                                         <h2 className="accordion-header mb-schem-head" id="flush-headingOne">
//                                             <div className="accordion-button collapsed d-block" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
//                                                 <div className='mb-sch-img'>
//                                                     <img alt='' src='/assets/images/green.png' className='log' />
//                                                 </div>
//                                                 <div className='mb-sch-name d-flex align-items-center justify-content-between'>
//                                                     <h5 className=' fw-bold pb-2'>{Goldplant_data?.name}</h5>
//                                                     <h6><ChevronDown /></h6>
//                                                 </div>
//                                             </div>
//                                         </h2>
//                                         <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
//                                             <div className='schema schemelen'>
//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Principal Returns After</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>{Goldplant_data?.returns_year ?? 0} year</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Assured Returns</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>{Goldplant_data?.payout_term ?? 0} year</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Minimum</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>₹ {Goldplant_data?.min_price ?? 0}</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Maximum</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>₹ {Goldplant_data?.max_price ?? 0}</p>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             <div className=' schema schemebtn-1'>
//                                                 <button type='button' onClick={() => {
//                                                     if (detail_info && token) {
//                                                         setSchemaData(Goldplant_data);
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         setchecked(false)
//                                                         document.getElementById("openPriceplanpopu")?.click();
//                                                     } else {
//                                                         setSchemaData(Goldplant_data);
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         setchecked(false)
//                                                         document.getElementById("loginPopupopen")?.click();
//                                                         setopenSchemes(true);
//                                                     }
//                                                 }} className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                 </button>

//                                                 <div className='details'>
//                                                     { token && detail_info ?
//                                                     <span onClick={() => router(`/scheme-detail/${Goldplant_data.plan_title}`)} className='btn'>
//                                                         Scheme Details
//                                                     </span>
//                                                      : ''}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div> */}
//                             </>) : ''
//                         }


//                         {
//                             digitalSilverPlan ? (
//                                 <>
//                                     <div className=' my-sm-4 my-md-0 col-md-6 col-lg-3 col-sm-12 chkclick fade-up mb-3' >
//                                         <div data-aos="fade-up" className='scheme-mbbox'>
//                                             {/* <div className='schema_main'>
//                                             <div className='top_active'>
//                                             <div className='benefits_flx'>
//                                                 <img alt='' src='/assets/images/green.png' className='log' />
//                                                 <div>
//                                                     <button id="blinking-button">Cashback Plan Silver</button>
//                                                 </div>
//                                                 </div>
//                                                 <h4 className=' fw-bold pb-2 mt-4'>{DigitaScheme?.name}</h4>
//                                             </div>
//                                             <div className='schema schemelen'>
//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Lock in Period</p>
//                                                     </div>

//                                                     <div>

//                                                         <p className='mb-0'>3 Years</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Active Plan</p>
//                                                     </div>

//                                                     <div>

//                                                         <p className='mb-0'>1 (gm)</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Minimum</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>₹ {DigitaScheme?.min_price ?? 0}</p>
//                                                     </div>
//                                                 </div>

//                                                 <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                     <div className="d-flex gap-2  align-items-center">
//                                                         <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                         <p className='mb-0'>Maximum</p>
//                                                     </div>

//                                                     <div>
//                                                         <p className='mb-0'>₹ {DigitaScheme?.max_price ?? 0}</p>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             <div className=' schema schemebtn-1'>
//                                                 <button type='button' onClick={() => {
//                                                     if (!detail_info && !token) {
//                                                         setSchemaData(DigitaScheme);
//                                                         setchecked(false)
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         document.getElementById("loginPopupopen")?.click();

//                                                     }
//                                                     else if (DigitaScheme?.cancel_status === 0) {
//                                                         toast.error('This Scheme already purchased')
//                                                     }
//                                                     else {
//                                                         setSchemaData(DigitaScheme);
//                                                         setchecked(false);
//                                                         document.getElementById('agreecheck').checked = false;
//                                                         document.getElementById("openPriceplanpopu")?.click();
//                                                     }
//                                                 }}

//                                                     className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                 </button>

//                                                 <div className='details'>
//                                                     { token && detail_info ?
//                                                     <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
//                                                         Scheme Details
//                                                     </span>
//                                                      : ''}
//                                                 </div>
//                                             </div>
//                                         </div> */}
//                                             <div className='quick_img'>
//                                                 <div className='plan_img'>
//                                                     <img alt='' src={digitalSilverPlan?.frontend_banner || '/assets/images/digital_saving_plan_2.png'} className='log' />
//                                                 </div>
//                                                 <div className=' schema schemebtn-1'>
//                                                     <button type='button' onClick={() => {
//                                                         if (!detail_info && !token) {
//                                                             setSchemaData(digitalSilverPlan);
//                                                             setchecked(false)
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("loginPopupopen")?.click();

//                                                         }
//                                                         else if (digitalSilverPlan?.cancel_status === 0) {
//                                                             toast.error('This Scheme already purchased')
//                                                             router("/user/digital-silver")
//                                                         }
//                                                         else {
//                                                             setSchemaData(digitalSilverPlan);
//                                                             setchecked(false);
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("openPriceplanpopu")?.click();
//                                                         }
//                                                     }}

//                                                         className='btn d-flex align-items-center gap-2'> Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                     </button>

//                                                     <div className='details'>
//                                                         {token && detail_info ?
//                                                             <span onClick={() => router(`/scheme-detail/${digitalSilverPlan.plan_title}`)} className='btn'>
//                                                                 Scheme Details
//                                                             </span>
//                                                             : ''}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* mobile-view */}

//                                     {/* <div className='d-block mb-scheme-box  d-sm-none my-2'>
//                                     <div className="accordion accordion-flush" id="accordionFlushExample">
//                                         <div className="accordion-item  mb-schem">
//                                             <h2 className="accordion-header mb-schem-head" id="flush-headingOne">
//                                                 <div className="accordion-button collapsed d-block" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
//                                                     <div className='mb-sch-img'>
//                                                         <img alt='' src='/assets/images/green.png' className='log' />
//                                                     </div>
//                                                     <div className='mb-sch-name d-flex align-items-center justify-content-between'>
//                                                         <h5 className=' fw-bold pb-2'>{DigitaScheme?.name}</h5>
//                                                         <h6><ChevronDown /></h6>
//                                                     </div>
//                                                 </div>
//                                             </h2>
//                                             <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
//                                                 <div className='schema schemelen'>
//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Lock in Period</p>
//                                                         </div>

//                                                         <div>

//                                                             <p className='mb-0'>3 Years</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Active Plan</p>
//                                                         </div>

//                                                         <div>

//                                                             <p className='mb-0'>1 (gm)</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Minimum</p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>₹ {DigitaScheme?.min_price ?? 0}</p>
//                                                         </div>
//                                                     </div>

//                                                     <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
//                                                         <div className="d-flex gap-2  align-items-center">
//                                                             <img alt='' src='/assets/iocns/Tick.png' className='' />
//                                                             <p className='mb-0'>Maximum</p>
//                                                         </div>

//                                                         <div>
//                                                             <p className='mb-0'>₹ {DigitaScheme?.max_price ?? 0}</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>

//                                                 <div className=' schema schemebtn-1'>
//                                                     <button type='button' onClick={() => {
//                                                         if (!detail_info && !token) {
//                                                             setSchemaData(DigitaScheme);
//                                                             setchecked(false)
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("loginPopupopen")?.click();

//                                                         }
//                                                         else if (DigitaScheme?.cancel_status === 0) {
//                                                             toast.error('This Scheme already purchased')
//                                                         }
//                                                         else {
//                                                             setSchemaData(DigitaScheme);
//                                                             setchecked(false);
//                                                             document.getElementById('agreecheck').checked = false;
//                                                             document.getElementById("openPriceplanpopu")?.click();
//                                                         }
//                                                     }}

//                                                         className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
//                                                     </button>

//                                                     <div className='details'>
//                                                         { token && detail_info ?
//                                                         <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
//                                                             Scheme Details
//                                                         </span>
//                                                         : ''}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div> */}
//                                 </>
//                             )
//                                 : ''
//                         }
//                     </div>
//                 }
//             </div>


//         </section>





//         {token && detail_info ? <section className='schema2' >



//             <div className='container'>
//                 {/* <div className='d-flex justify-content-center w-100 text-center titsksd mb-3'>
//                     <div>
//                         <div data-aos="fade-up-right">
//                             <img src='/assets/images/shpas.png' alt='' />
//                         </div>
//                         <div data-aos="fade-up-left">
//                             <h2 className='fw-bold mb-0'>Returns with Gold Investment Leaf </h2>
//                             <h2 className='fw-bold mb-4'>(SIP Scheme)</h2>
//                         </div>
//                     </div>
//                 </div>
//                 <div className='mb-3'>
//                     <div data-aos="fade-up">
//                         <div className='d-flex schematable gap-2'>
//                             <div>
//                                 <div className='mb-2 leaft leaft-head text-center G1'>
//                                     <h5 className='text-light'>Gold Investment Leaf Scheme</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center  G2'>
//                                     <h5>3 months (0-90 days)</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center G3'>
//                                     <h5>6 months (90-180 days)</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center G4'>
//                                     <h5>9 months (180 - 270 days)</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center G5'>
//                                     <h5>12 months (270 - 360 days)</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center G6'>
//                                     <h5>2nd Year</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center G7'>
//                                     <h5>3rd Year</h5>
//                                 </div>
//                             </div>

//                             <div>
//                                 <div className='mb-2 leaft  leaft-head  text-center C1'>
//                                     <h5>GreenHeap Gold approx. (1,000 assured)</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2 '>
//                                     <h5>(0.25% x 3m) Rs. 7.50</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(0.5% X 6m) Rs. 30.00</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(0.75% X 9m) Rs. 67.50</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(1% X 12m) Rs. 120.00</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(1% X 24m) Rs. 240.00</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(1% X 36m) Rs. 360.00</h5>
//                                 </div>
//                             </div>

//                             <div>
//                                 <div className='mb-2 leaft  leaft-head text-center C1'>
//                                     <h5>GreenHeap Silver Bonus</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(9.6% per annum For 3m) Rs. 24.00</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(10% per annum For 6m) Rs. 50.00</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(12% per annum For 9m) Rs. 90.00</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(14% per annum For 12m) Rs. 140.00</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(18% per annum For 24m) Rs. 360.00</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(20% per annum For 36m) Rs. 600.00</h5>
//                                 </div>
//                             </div>

//                             <div>
//                                 <div className='mb-2 leaft  leaft-head text-center C1'>
//                                     <h5>GreenHeap Gold + Silver Bonus</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(7.50 + 24.00) Rs. 31.5</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(30.00 + 50.00) Rs. 80</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(67.50 + 90.00) Rs. 157.5</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(120.00 + 140.00) Rs. 260</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(240.00 + 360.00) Rs. 600</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center C2'>
//                                     <h5>(360.00 + 600.00) Rs. 960</h5>
//                                 </div>
//                             </div>

//                             <div>
//                                 <div className='mb-2 leaft text-center px-lg-1 leaft-head F1'>
//                                     <h5 className='text-light m-0'>Sip Total Returns</h5>
//                                     <h5 className='text-light'>(Cash Back)</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center F2'>
//                                     <h5>31.5</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center F3'>
//                                     <h5>80</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center F4'>
//                                     <h5>157.5</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center F5'>
//                                     <h5>260</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center F6'>
//                                     <h5>600</h5>
//                                 </div>

//                                 <div className='mb-2 leaft text-center F7'>
//                                     <h5>960</h5>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                 </div> */}
//                 <div data-aos="fade-left">
//                     <div className='text-center'>
//                         <h5 className='terms-text'>
//                             <span className='' style={{ cursor: "pointer" }} onClick={() => { router(`/pages/${footerpage[0]?.slug}`) }}>*Terms & Conditions are apply
//                             </span>
//                         </h5>
//                     </div>
//                 </div>
//             </div>
//         </section> : <section className='center_banner'>
//             <div className='center_banner_img'>
//                 <img src='\assets\iocns\center_banner2.jpg' className='img-fluid' />
//             </div>
//         </section>}

//         {/* qr-code-modal */}

//         <section>
//             <button type="button" className="btn btn-primary d-none" data-toggle="modal" data-target="#offlinebox" id='offlinepop-pup'>
//                 Launch demo modal
//             </button>
//             <div className="modal fade" id="offlinebox" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
//                 <div className="modal-dialog modal-dialog-centered">
//                     <div className='modal-content'>
//                         <div className="modal-header">
//                             <h1 className="modal-title fs-5 schemename" id="razarpaypopupLabel"><span className='mx-2' style={{ cursor: 'pointer' }} onClick={() => { document.getElementById('offlinepop-pup').click(); document.getElementById('payment-pup').click() }}><ArrowLeft /></span>{shemData?.plan_title === "digital_plan" ? `${shemData?.name}(Cash Back)` : shemData?.plan_title === "gold_plant" ? `${shemData?.name}(Monthly Rental)` : shemData?.name}</h1>

//                             <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('offlinepop-pup').click() }} ></button>
//                         </div>
//                         <div className="modal-body">
//                             <div className="d-flex mb-2 mt-2 justify-content-center align-items-center gap-1" >
//                                 <img src="/assets/images/g-pay.png" alt="gpay" height={70} />
//                                 <img src="/assets/images/phone-pe.png" alt="phonepay" height={50} />

//                                 <div className="d-flex text-center align-items-center qr-upiid justify-content-between ">

//                                     <h6 className="mb-0">{phonumber}</h6>
//                                     <button
//                                         className="btn btn-sm"
//                                         style={{ fontSize: "1rem" }}
//                                         onClick={() => handleCopy(phonumber, "phone")}
//                                     >
//                                         <FaCopy
//                                             className={`${copiedField === "phone" ? "text-dark" : "text-secondary"}`}
//                                         />
//                                     </button>

//                                     {/* <FaCopy className={`${copied ? "text-dark" : "text-secondary"} `}  onClick={() => handleCopy(upiId)} /> */}

//                                 </div>
//                             </div>
//                             <div className="qr-detail text-center">
//                                 <h6>{setting_data ? setting_data[0]?.account_holder : ''}</h6>
//                             </div>
//                             <div className='d-flex justify-content-center'>
//                                 <div className="qr-upiid d-flex justify-content-center align-items-center">
//                                     <button
//                                         className="btn btn-sm"
//                                         style={{ fontSize: "1rem" }}
//                                         onClick={() => handleCopy(upiId, "upi")}
//                                     >
//                                         <FaCopy
//                                             className={`${copiedField === "upi" ? "text-dark" : "text-secondary"}`}
//                                         />
//                                     </button>
//                                     <h6 className="mb-0">{upiId}</h6>

//                                     {/* <h6 className='mb-0'>Vyapar.171813426519@hdfcbank</h6> */}
//                                 </div>
//                             </div>
//                             <div className="qq-sacn-img p-2">
//                                 <img src={setting_data ? setting_data[0]?.qr_code : ''} alt='' className='img-fluid' />
//                             </div>
//                             <form onSubmit={upimethod}>
//                                 <div className="uplo-img ">
//                                     <input type='file' className='d-none' id='scanimg' onChange={screenshot} />
//                                     <button className='btn' type='button' onClick={() => { document.getElementById('scanimg').click() }}>Upload Payment ID PHOTO/IMAGE HERE <img src='\assets\iocns\upload.png' alt='' className='img-fluid' /></button>
//                                     {!file1 && <span className="text-end d-block mt-2">
//                                         <div
//                                             className="d-flex align-items-center justify-content-end gap-2"
//                                             style={{ cursor: "pointer" }}
//                                             onClick={handleOpen}
//                                         >
//                                             <img
//                                                 src="/assets/iocns/eye.png"
//                                                 alt="preview"
//                                                 className="text-danger"
//                                                 style={{ width: "24px", height: "24px" }}
//                                             />
//                                             <span className="text-secondary">Example Transaction Slip</span>
//                                         </div>
//                                     </span>}

//                                     {/* Bootstrap Modal */}
//                                     <Modal show={showModal} onHide={handleClose} centered>
//                                         <Modal.Header closeButton>
//                                             <Modal.Title>Example Transaction Slip</Modal.Title>
//                                         </Modal.Header>
//                                         <Modal.Body className="text-center">
//                                             <img
//                                                 src="/assets/images/example_slip.jfif"
//                                                 alt="Preview"
//                                                 style={{ maxWidth: "100%", maxHeight: "600px" }}
//                                             />
//                                         </Modal.Body>

//                                     </Modal>
//                                     {
//                                         file1 ? (
//                                             <>
//                                                 <div className='uploadfile-name position-relative'>
//                                                     <p className='m-0'>{file1 ? `File Name : ${file1}` : ''}</p>
//                                                     <h6 className='position-absolute remove-upload' onClick={() => { setfile1(); settransfile() }}><X /></h6>
//                                                 </div>
//                                             </>
//                                         ) : ''
//                                     }

//                                     <input type="text" className="form-control bg-white text-dark border text-center my-2" placeholder="SEND (or) PASTE SMS Transaction ID Here" aria-label="transaction-id" id='transaction-id' onChange={(e) => { setTranscationid(e.target.value) }} />
//                                     <p className='text-danger '>* Upload the transaction slip or enter the transaction ID</p>
//                                 </div>
//                                 <div className="update-profile">
//                                     <button className="text-white" type="submit">{spinner ? <span className="spinner-border spinner-border-sm " role="status"></span> : 'Continue'}</button>
//                                 </div>
//                             </form>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </section>


//         <Snackbar
//             open={openSnackbar}
//             autoHideDuration={2000}
//             onClose={handleCloseSnackbar}
//             anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         >
//             <Alert onClose={handleCloseSnackbar} sx={{ width: "100%" }}>
//                 Copied to clipboard!
//             </Alert>
//         </Snackbar>
//         {/* payment-modal */}

//         <section>
//             <button type="button" className="btn btn-primary d-none" data-toggle="modal" data-target="#paymentbox" id='payment-pup'>
//                 Launch demo modal
//             </button>
//             <div className="modal fade" id="paymentbox" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
//                 <div className="modal-dialog modal-dialog-centered">
//                     <div className='modal-content'>
//                         <div className="modal-header">
//                             <h1 className="modal-title fs-5 schemename" id="razarpaypopupLabel">{shemData?.plan_title === "digital_plan" ? `${shemData?.name}(Cash Back)` : shemData?.plan_title === "gold_plant" ? `${shemData?.name}(Monthly Rental)` : shemData?.name}</h1>
//                             <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('payment-pup').click() }} ></button>
//                         </div>
//                         <div className="modal-body">
//                             <div className="pm-ti">
//                                 <h5> Choose Payment Method</h5>
//                             </div>
//                             <div className="pm-choice ">
//                                 <form onSubmit={paymentfun}>
//                                     <div className={process_type == '2' ? 'form-check act' : 'form-check'} >
//                                         <div className="selecttypes p-2  d-flex align-items-center gap-2">
//                                             <input className="form-check-input  mb-1" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="2" onChange={(e) => { setprocess_type(e.target.value) }} />
//                                             {/* <label className="form-check-label" htmlFor="inlineRadio2">QR code / UPI</label> */}
//                                             <label className="form-check-label" htmlFor="inlineRadio2">Direct UPI Payments (QR Code) </label>
//                                             <div className='razoricon'><img src='\assets\images\upis.png' className='img-fluid' alt='' /></div>
//                                         </div>
//                                     </div>
//                                     <div className={process_type == '1' ? 'form-check act' : 'form-check'}>
//                                         <div className="selecttypes p-2 d-flex align-items-center gap-2">
//                                             <input className="form-check-input mb-1" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" onChange={(e) => { setprocess_type(e.target.value) }} />
//                                             <label className="form-check-label" htmlFor="inlineRadio1">
//                                                 <div className='razoricon'>
//                                                     <img src='\assets\images\visa.png' className='img-fluid' alt='' />
//                                                     <img src='\assets\images\mascard.png' className='img-fluid' alt='' />
//                                                     <img src='\assets\images\rupay.png' className='img-fluid' alt='' />
//                                                     <img src='\assets\images\phopay.png' className='img-fluid' alt='' />
//                                                     <img src='\assets\images\mastro.png' className='img-fluid' alt='' />
//                                                 </div>
//                                             </label>

//                                             {/* <div className='razoricon'>
//                                                 <img src='\assets\images\visa.png' className='img-fluid' alt='' />
//                                                 <img src='\assets\images\mascard.png' className='img-fluid' alt='' />
//                                                 <img src='\assets\images\rupay.png' className='img-fluid' alt='' />
//                                                 <img src='\assets\images\phopay.png' className='img-fluid' alt='' />
//                                                 <img src='\assets\images\mastro.png' className='img-fluid' alt='' />
//                                             </div> */}
//                                         </div>
//                                     </div>

//                                     <div className={process_type == '3' ? 'form-check act' : 'form-check'}>
//                                         <div className="selecttypes py-3 px-2  d-flex align-items-center gap-2">
//                                             <input className="form-check-input  mb-1" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="3" onChange={(e) => { setprocess_type(e.target.value) }} />
//                                             {/* <label className="form-check-label" htmlFor="inlineRadio3">Bank Details</label> */}
//                                             <label className="form-check-label" htmlFor="inlineRadio3">For RTGS / NEFT / IMPS</label>
//                                             <div className='banic'><img src='assets\images\net_img.png' className='img-fluid' alt='' /></div>
//                                         </div>
//                                     </div>
//                                     <div className="update-profile ">
//                                         <button className="text-white" type="submit">Continue</button>
//                                     </div>
//                                 </form>
//                             </div>

//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </section>

//         {/* bandetail-modal */}

//         <section>
//             <button type="button" className="btn btn-primary d-none" data-toggle="modal" data-target="#bankbox" id='bankpop-pup'>
//                 Launch demo modal
//             </button>
//             <div className="modal fade" id="bankbox" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
//                 <div className="modal-dialog modal-dialog-centered">
//                     <div className='modal-content'>
//                         <div className="modal-header">
//                             <h1 className="modal-title fs-5 schemename" id="razarpaypopupLabel"><span className='mx-1' style={{ cursor: 'pointer' }} onClick={() => { document.getElementById('bankpop-pup').click(); document.getElementById('payment-pup').click() }}><ArrowLeft /></span> {shemData?.plan_title === "digital_plan" ? `${shemData?.name}(Cash Back)` : shemData?.plan_title === "gold_plant" ? `${shemData?.name}(Monthly Rental)` : shemData?.name} </h1>

//                             <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('bankpop-pup').click() }} ></button>
//                         </div>
//                         <div className="modal-body ac-holdbank">
//                             <h5 className='mb-4'>Bank Details</h5>

//                             <div className="acc-holder">
//                                 <img src='\assets\iocns\Profile.png' className='img-fluid' alt='' /><span>Account Name : {setting_data ? setting_data[0]?.account_holder : ''}</span>
//                             </div>
//                             <div className="acc-holder">
//                                 <img src='\assets\iocns\accountnumber.png' className='img-fluid' alt='' /><span>Account Number : {setting_data ? setting_data[0]?.account_number : ''}</span>
//                             </div>
//                             <div className="acc-holder">
//                                 <img src='\assets\iocns\bank.png' className='img-fluid' alt='' /><span>Bank Name : {setting_data ? setting_data[0]?.bank_name : ''}</span>
//                             </div>
//                             <div className="acc-holder">
//                                 <img src='\assets\iocns\branchlocatin.png' className='img-fluid' alt='' /><span>Branch Name : {setting_data ? setting_data[0]?.branch_name : ''}</span>
//                             </div>
//                             <div className="acc-holder">
//                                 <img src='\assets\iocns\ifsc code.png' className='img-fluid' alt='' /><span>IFSC Code : {setting_data ? setting_data[0]?.ifsc_code : ''}</span>
//                             </div>
//                             <form onSubmit={Bankmethod}>

//                                 <div className="uplo-img text-start">
//                                     <input type='file' className='d-none' id='scanimg' onChange={screenshot} />
//                                     <button className='btn ' type='button' onClick={() => { document.getElementById('scanimg').click() }}>Upload Payment ID PHOTO/IMAGE HERE  <img src='\assets\iocns\upload.png' alt='' className='img-fluid' /></button>
//                                     {
//                                         file1 ? (
//                                             <>
//                                                 <div className='uploadfile-name position-relative'>
//                                                     <p className='m-0'>{file1 ? `File Name : ${file1}` : ''}</p>
//                                                     <h6 className='position-absolute remove-upload' onClick={() => { setfile1(); settransfile() }}><X /></h6>
//                                                 </div>
//                                             </>
//                                         ) : ''
//                                     }
//                                     <input type="text" className="form-control bg-white text-dark border text-center my-2" placeholder="SEND (or) PASTE SMS Transaction ID Here" id='transaction-id2' aria-label="transaction-id" onChange={(e) => { setTranscationid(e.target.value) }} />
//                                     <p className='text-danger '>* Upload the transaction slip or enter the transaction ID</p>
//                                 </div>

//                                 <div className="update-profile mt-2 mb-0">
//                                     <button className="text-white" type="submit" >{spinner ? <span className="spinner-border spinner-border-sm " role="status"></span> : 'Continue'}</button>
//                                 </div>
//                             </form>



//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </section>

//     </>
//     )
// }

// const renderPlans = (plans) => {
//     if (!plans || plans.length === 0) {
//         return <p>No plans available.</p>;
//     }

//     return plans.map((plan) => (
//         <div key={plan.id} className="active-plan-card mb-3">
//             <img
//                 src={`/assets/images/${plan.image}`}
//                 alt={plan.name}
//                 className="plan-image"
//             />
//             <h3>{plan.name}</h3>
//             <p>Tenure: {plan.plan_tenure} months</p>
//             <p>Bonus: {plan.bonus}%</p>
//             <p>Min Price: ₹{plan.min_price}</p>
//             <p>Max Price: ₹{plan.max_price}</p>
//             <p>Label: {plan.label}</p>
//             {plan.page && (
//                 <a href={`/plans/${plan.page.slug}`} className="btn btn-primary">
//                     View Terms & Conditions
//                 </a>
//             )}
//         </div>
//     ));
// };




import axios from 'axios'
import React, { useEffect, useState, useCallback, useContext, useRef } from 'react'
import { Enroll_fun, fetchBeneficiaries, getSavingPlan_fun, postSchemaSave } from '../api/Pageapi';
import { useRazorpay } from "react-razorpay";
import toast, { useToaster } from 'react-hot-toast';
import { Logindetail } from '../context/Logindetail';
import { useNavigate } from 'react-router-dom';
import { Shimmer } from 'react-shimmer';
import { Digitalscheme_fun, Getdigital_trans, GetPlanbenefit, Savedigitalplan, SavedigitalSilverplan } from '../api/RouteScheme2';
import { GoldPlant_fun, SaveGoldplan } from '../api/RouteScheme3';
import { Footerpages } from '../context/Footerpages';
import { schemeplans } from '../api/Controllapi';
import AOS from 'aos';
import { SchemeDetails } from '../context/SchemeDetails';
import { capture_payment } from '../api/Controllapi';
import { Arrow90degLeft, ArrowLeft, ArrowUp, ArrowUpShort, ChevronDown, X } from 'react-bootstrap-icons';
import { RazarDetails } from '../context/razarApi';
import { Snackbar, Alert } from '@mui/material';
import { FaCopy } from 'react-icons/fa';
import { Modal, Button } from "react-bootstrap";
import DigitalSilverScheme from '../dashboard/DigitalSilverSchemes';
import { getShemesSchedule } from "../api/Pageapi"
import { Getdigital_silver_trans } from "../api/RouteScheme2"
import { GetGoldPlantApi } from "../api/RouteScheme3"
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar } from "swiper/modules";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";



import Select from 'react-select';



export default function Schemes({ setopenSchemes, setting_data }) {



    //new
    const [new_razar_key, setNew_razar_key] = useState(0)






    const fetchKey = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}razorpay_key`);
            if (response?.data?.razorpay_key) {
                const newKey = response.data.razorpay_key;
                // const storedKey = localStorage.getItem('razorpay_key');

                if (newKey) {
                    // Key is different, update state and localStorage
                    setNew_razar_key(newKey);
                    // localStorage.setItem('razorpay_key', newKey);
                }
                // else: keys are same, no update needed
            } else {
                throw new Error("Invalid response format");
            }
        } catch (error) {
            console.error('Failed to fetch Razorpay key:', error);
            // toast.error("Unable to load Razorpay key. Please try again later.");
        }
    };


    ///

    //  const new_razar_key = localStorage.getItem('razorpay_key');

    // console.log("new razar.......from scheme...........",new_razar_key)

    const router = useNavigate();

    //added key
    const RAZAR_KEY = new_razar_key;




    //default key
    // const RAZAR_KEY = "rzp_test_K7CipNQYyyMPiS";




    // const RAZAR_KEY = "rzp_live_FZ6iVw5tcRGpW5";

    // const RAZAR_KEY= razorpayKey;




    const { token, detail_info, setdetail_info } = useContext(Logindetail)



    const { setschemelist } = useContext(SchemeDetails)
    const [scheme_list, setscheme_list] = useState({});
    const { error, isLoading: isRazorpayLoading, Razorpay } = useRazorpay();
    const [showRazorpayModal, setShowRazorpayModal] = useState(false);
    const [shemData, setSchemaData] = useState()
    const [price, setprice] = useState();
    const [isLoading, setisLoading] = useState(true);
    const [benfic, setbenfic] = useState([]);
    const [DigitaScheme, setDegitalScheme] = useState({})
    const [digitalSilverPlan, setDigitalSilverPlan] = useState()
    const [Benifitid, setBenifitid] = useState()
    const [Goldplant_data, setGoldplant_data] = useState()
    const [checked, setchecked] = useState(false)
    const { footerpage } = useContext(Footerpages)
    const fromsubmit = useRef()
    const [ChargeAmt, setChargeAmt] = useState()
    const [benificid, setbenificid] = useState('')
    const [process_type, setprocess_type] = useState()
    const [clientamount, setclientamount] = useState()
    const [Transactionid, setTranscationid] = useState()
    const [transfile, settransfile] = useState()
    const [file1, setfile1] = useState()
    const [spinner, setspinner] = useState()
    const [Enroll_data, setEnroll_data] = useState()


    // const navi = useNavigate()



    const logout = () => {
        localStorage.removeItem("green_login")
        localStorage.removeItem("phone")
        localStorage.removeItem("green_token")
        localStorage.removeItem("kyc")
        router('/');
        setdetail_info();
    }

    const handlefectch = () => {
        fetchBeneficiaries()
            .then(res => {
                setbenfic(res?.data)
                setisLoading(false);
                if (res?.data?.status == 403) {
                    logout();
                }
            }).catch(err => {
                // console.log('err', err.message);
                setisLoading(false)
            });
    }

    useEffect(() => {
        if (detail_info && token) {
            handlefectch()
        } else {
            setisLoading(false)
        }
    }, [detail_info?.id, token])

    useEffect(() => {
        fetchKey()
    }, [])


    // 1 plan
    const handlePayment = useCallback(async () => {

        const options = {
            key: RAZAR_KEY,
            amount: (clientamount) * 100,
            currency: "INR",
            name: 'Greenheap',
            description: 'Greenheap',
            image: "/assets/iocns/__Fav Icon.png",
            handler: (res) => {
                const transactionId = res.razorpay_payment_id;
                const body = {
                    "amount": clientamount,
                    "saving_plan_id": shemData?.id,
                    "transaction_id": res?.razorpay_payment_id,
                    'benificiar': benificid,
                    "payment_method": 'razor_pay',
                }
                postSchemaSave(body, token).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    router('/user/dashboard')
                    toast.success(`Payment successful from ${shemData?.name}`)
                    setShowRazorpayModal(false);
                    let resBody = {
                        "paymentId": transactionId,
                        "amount": clientamount
                    }

                    capture_payment(resBody)
                        .then((res) => {
                            // console.log(res)
                        })
                        .catch((e) => {
                        })
                }).catch(err => {
                })
            },

            theme: {
                color: '#650020',
            },
        };

        const rzpay = new Razorpay(options);

        rzpay.open();

        // Reset the showRazorpayModal state after payment completion

        rzpay.on('payment.failed', function (response) {
            setShowRazorpayModal(false);
            console.error(response.error.description);
            toast.error(response.error.description)
        });

    }, [price, shemData]);

    // 2 plan

    const handlePaymentDigital = useCallback(async () => {

        const options = {
            key: RAZAR_KEY,
            amount: (clientamount) * 100,
            currency: "INR",
            name: 'Greenheap',
            description: 'Greenheap',
            image: "/assets/iocns/__Fav Icon.png",
            handler: (res) => {

                const transactionId = res.razorpay_payment_id;

                const body = {
                    "digital_plan_id": shemData?.id,
                    "amount": clientamount,
                    "transaction_id": res?.razorpay_payment_id,
                    // 'benificiar': benificid,
                    "payment_method": 'razor_pay',
                }
                Savedigitalplan(body).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    router('/user/dashboard')
                    toast.success(`Payment successful from ${shemData?.name}`)
                    setShowRazorpayModal(false);

                    let resBody = {
                        "paymentId": transactionId,
                        "amount": clientamount
                    }

                    capture_payment(resBody)
                        .then((res) => {
                            // console.log("done")
                        })
                        .catch((e) => {
                        })


                }).catch(err => {
                })


            },
            theme: {
                color: '#650020',
            },
        };

        const rzpay = new Razorpay(options);

        rzpay.open();

        // Reset the showRazorpayModal state after payment completion
        rzpay.on('payment.failed', function (response) {
            setShowRazorpayModal(false);
            console.error(response.error.description);
            toast.error(response.error.description)
        });

    }, [price, shemData]);

    //-- silver plan --//

    const handlePaymentDigitalSilver = useCallback(async () => {

        const options = {
            key: RAZAR_KEY,
            amount: (clientamount) * 100,
            currency: "INR",
            name: 'Greenheap',
            description: 'Greenheap',
            image: "/assets/iocns/__Fav Icon.png",
            handler: (res) => {

                const transactionId = res.razorpay_payment_id;

                const body = {
                    "digital_plan_id": shemData?.id,
                    "amount": clientamount,
                    "transaction_id": res?.razorpay_payment_id,
                    // 'benificiar': benificid,
                    "payment_method": 'razor_pay',
                }
                SavedigitalSilverplan(body).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    router('/user/dashboard')
                    toast.success(`Payment successful from ${shemData?.name}`)
                    setShowRazorpayModal(false);

                    let resBody = {
                        "paymentId": transactionId,
                        "amount": clientamount
                    }

                    capture_payment(resBody)
                        .then((res) => {
                            // console.log("done")
                        })
                        .catch((e) => {
                        })


                }).catch(err => {
                })


            },
            theme: {
                color: '#650020',
            },
        };

        const rzpay = new Razorpay(options);

        rzpay.open();

        // Reset the showRazorpayModal state after payment completion
        rzpay.on('payment.failed', function (response) {
            setShowRazorpayModal(false);
            console.error(response.error.description);
            toast.error(response.error.description)
        });

    }, [price, shemData]);
    //--//
    // 3 plan
    const handlePaymentgoldplant = useCallback(async () => {
        const options = {
            key: RAZAR_KEY,
            amount: (ChargeAmt) * 100,
            currency: "INR",
            name: 'Greenheap',
            description: 'Greenheap',
            image: "/assets/iocns/__Fav Icon.png",
            handler: (res) => {

                const transactionId = res.razorpay_payment_id;
                const clientamount = ChargeAmt

                const body = {
                    "gold_plant_id": shemData?.id,
                    "amount": ChargeAmt,
                    "transaction_id": res?.razorpay_payment_id,
                    'benificiar': Benifitid,
                    "payment_method": 'razor_pay',
                }
                SaveGoldplan(body).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    router('/user/dashboard')
                    toast.success(`Payment successful from ${shemData?.name}`)
                    setShowRazorpayModal(false);
                    setbenificid()


                    let resBody = {
                        "paymentId": transactionId,
                        "amount": clientamount
                    }

                    capture_payment(resBody)
                        .then((res) => {
                            // console.log(res)
                        })
                        .catch((e) => {
                        })


                }).catch(err => {
                })
            },
            theme: {
                color: '#650020',
            },
        };

        const rzpay = new Razorpay(options);

        rzpay.open();

        // Reset the showRazorpayModal state after payment completion
        rzpay.on('payment.failed', function (response) {
            setShowRazorpayModal(false);
            console.error(response.error.description);
            toast.error(response.error.description)
        });

    }, [ChargeAmt, shemData]);

    const [Shcudle, setShcudle] = useState([])

    const [digita_shedule, setdigital_shedule] = useState([])
    const [digital_silver, setDigital_silver] = useState([])
    const [gold_shedule, setgold_shedule] = useState([])

    const [chitPlanData, setPlanData] = useState([])



    const handleGetSchema = () => {
        setisLoading(true)
        getShemesSchedule(token).then(res => {
            setShcudle(res);
            setPlanData(res?.data)

            setisLoading(false)
        }).catch(err => {
            setisLoading(false)
        })
    }

    const handleDigitalSchmea = () => {
        Getdigital_trans()
            .then((res) => {
                setdigital_shedule(res)

                setisLoading(false)
            })
            .catch((err) => {
                setisLoading(false)
            })
    }

    const handleDigitalSilver = () => {
        Getdigital_silver_trans()
            .then((res) => {
                setDigital_silver(res)
                setisLoading(false)
            })
            .catch((err) => {
                setisLoading(false)
            })
    }

    const handleGoldGetSchema = () => {
        setisLoading(true)
        GetGoldPlantApi(token).then(res => {
            setgold_shedule(res)
            setisLoading(false)
        }).catch(err => {
            setisLoading(false)
        })
    }



    const handlepayModal = () => {
        if (shemData?.plan_title === "saving_plan") {
            handlePayment()
        }
        if (shemData?.plan_title === "digital_plan") {
            handlePaymentDigital()
        }
        if (shemData?.plan_title === "digital_silver_plan") {
            handlePaymentDigitalSilver()
        }
        if (shemData?.plan_title === "gold_plant") {
            handlePaymentgoldplant();
        }
    }
    useEffect(() => {
        if (token) {
            handleGetSchema();
            // handleDigitalSchmea();
            // handleGoldGetSchema();
            // handleDigitalSilver();
        }
    }, [token]);

    useEffect(() => {
        const handleAutoOpen = () => {
            const autoOpen = localStorage.getItem("autoOpenSchemePopup");
            const pendingScheme = localStorage.getItem("pendingScheme");
            if (autoOpen === "true" && !isLoading && pendingScheme) {
                localStorage.removeItem("autoOpenSchemePopup");
                localStorage.removeItem("pendingScheme");
                try {
                    const scheme = JSON.parse(pendingScheme);
                    setSchemaData(scheme);
                    setTimeout(() => {
                        const btn = document.getElementById('openPriceplanpopu');
                        if (btn) {
                            btn.click();
                            if (document.getElementById('agreecheck')) {
                                document.getElementById('agreecheck').checked = false;
                            }
                            setchecked(false);
                        }
                    }, 200);
                } catch (e) {
                    console.error("Error parsing pendingScheme", e);
                }
            }
        };

        handleAutoOpen();

        window.addEventListener('autoOpenScheme', handleAutoOpen);
        return () => {
            window.removeEventListener('autoOpenScheme', handleAutoOpen);
        };
    }, [isLoading]);



    useEffect(() => {
        AOS.init({
            duration: 1500
        });
    }, []);

    const getscheme_plans = () => {
        schemeplans(detail_info?.id ? detail_info?.id : '')
            .then((res) => {
                setscheme_list(res?.data[0])
                setDegitalScheme(res?.data[1])
                setGoldplant_data(res?.data[2])
                setDigitalSilverPlan(res?.data[3])
                setisLoading(false)
                setschemelist(res?.data)
            })
            .catch((err) => {
                setisLoading(false)
            })
    }


    useEffect(() => {
        getscheme_plans()
    }, [detail_info?.id])



    const paymentfun = (e) => {
        e.preventDefault()

        if (process_type == '1') {
            setShowRazorpayModal(true);
            handlepayModal();
            document.getElementById('payment-pup').click()
            document.getElementById('Rupees').value = null
        }
        else if (process_type == '2') {
            document.getElementById('payment-pup').click()
            document.getElementById('offlinepop-pup').click()
            document.getElementById('transaction-id').value = null
            setfile1()
            settransfile()
            setTranscationid()
        }
        else if (process_type == '3') {
            document.getElementById('payment-pup').click()
            document.getElementById('bankpop-pup').click()
            document.getElementById('transaction-id2').value = null
            setTranscationid()
        }
        else {
            toast.error('please select payment method')
        }

    }

    const upimethod = (e) => {
        e.preventDefault()

        if (!transfile) {
            toast.error('please Upload the transaction slip');
            return false;
        }

        if (shemData?.plan_title === 'saving_plan') {

            if (Transactionid || transfile) {

                setspinner(true)

                const formdata = new FormData()
                formdata.append('amount', clientamount)
                formdata.append('saving_plan_id', shemData?.id)
                formdata.append('transaction_id', Transactionid ? Transactionid : null)
                formdata.append('benificiar', benificid)
                formdata.append('payment_method', 'upi')
                formdata.append('uploads', transfile)

                postSchemaSave(formdata).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    setspinner(false)
                    // toast.success(`Payment successful from ${shemData?.name}`)
                    toast.success('Transaction submitted successfully. Please wait for admin approval')

                    document.getElementById('offlinepop-pup').click()
                    router('/user/dashboard')

                    setShowRazorpayModal(false);
                }).catch(err => {
                })


            }
            else {
                toast.error('please Upload the transaction slip or enter the transaction ID')
            }
        }

        if (shemData?.plan_title === "digital_plan") {

            if (Transactionid || transfile) {

                setspinner(true)
                const formdata = new FormData()
                formdata.append('amount', clientamount)
                formdata.append('digital_plan_id', shemData?.id)
                formdata.append('transaction_id', Transactionid ? Transactionid : null)
                formdata.append('benificiar', benificid)
                formdata.append('payment_method', 'upi')
                formdata.append('uploads', transfile)

                Savedigitalplan(formdata).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    // toast.success(`Payment successful from ${shemData?.name}`)
                    toast.success('Transaction submitted successfully. Please wait for admin approval')

                    document.getElementById('offlinepop-pup').click()
                    router('/user/dashboard')


                    setShowRazorpayModal(false);
                    setspinner(false)
                }).catch(err => {
                })


            }
            else {
                toast.error('please Upload the transaction slip or enter the transaction ID')
            }
        }

        if (shemData?.plan_title === "digital_silver_plan") {

            if (Transactionid || transfile) {

                setspinner(true)
                const formdata = new FormData()
                formdata.append('amount', clientamount)
                formdata.append('digital_plan_id', shemData?.id)
                formdata.append('transaction_id', Transactionid ? Transactionid : null)
                formdata.append('benificiar', benificid)
                formdata.append('payment_method', 'upi')
                formdata.append('uploads', transfile)

                SavedigitalSilverplan(formdata).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    // toast.success(`Payment successful from ${shemData?.name}`)
                    toast.success('Transaction submitted successfully. Please wait for admin approval')

                    document.getElementById('offlinepop-pup').click()
                    router('/user/dashboard')


                    setShowRazorpayModal(false);
                    setspinner(false)
                }).catch(err => {
                })


            }
            else {
                toast.error('please Upload the transaction slip or enter the transaction ID')
            }
        }

        if (shemData?.plan_title === "gold_plant") {

            if (Transactionid || transfile) {

                setspinner(true)

                const formdata = new FormData()
                formdata.append('amount', clientamount)
                formdata.append('gold_plant_id', shemData?.id)
                formdata.append('transaction_id', Transactionid ? Transactionid : null)
                formdata.append('benificiar', benificid)
                formdata.append('payment_method', 'upi')
                formdata.append('uploads', transfile)

                SaveGoldplan(formdata).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    // toast.success(`Payment successful from ${shemData?.name}`)
                    toast.success('Transaction submitted successfully. Please wait for admin approval')

                    document.getElementById('offlinepop-pup').click()
                    router('/user/dashboard')


                    setShowRazorpayModal(false);
                    setspinner(false)
                }).catch(err => {
                })


            }
            else {
                toast.error('please Upload the transaction slip or enter the transaction ID')
            }
        }

    }

    const Bankmethod = (e) => {
        e.preventDefault()

        if (!transfile) {
            toast.error('please Upload the transaction slip');
            return false;
        }

        if (shemData?.plan_title === 'saving_plan') {

            if (Transactionid || transfile) {

                setspinner(true)

                const formdata = new FormData()
                formdata.append('amount', clientamount)
                formdata.append('saving_plan_id', shemData?.id)
                formdata.append('transaction_id', Transactionid ? Transactionid : null)
                formdata.append('benificiar', benificid)
                formdata.append('payment_method', 'bank')
                formdata.append('uploads', transfile)

                postSchemaSave(formdata).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    // toast.success(`Payment successful from ${shemData?.name}`)
                    // toast.success('Transaction submitted successfully. Please wait for admin approval')

                    document.getElementById('bankpop-pup').click()
                    router('/user/dashboard')
                    setShowRazorpayModal(false);
                    setspinner(false)
                }).catch(err => {
                })
            }
            else {
                toast.error('please Upload the transaction slip or enter the transaction ID')
            }
        }
        if (shemData?.plan_title === "digital_plan") {

            if (Transactionid || transfile) {

                setspinner(true)

                const formdata = new FormData()
                formdata.append('amount', clientamount)
                formdata.append('digital_plan_id', shemData?.id)
                formdata.append('transaction_id', Transactionid ? Transactionid : null)
                formdata.append('benificiar', benificid)
                formdata.append('payment_method', 'bank')
                formdata.append('uploads', transfile)

                Savedigitalplan(formdata).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    // toast.success(`Payment successful from ${shemData?.name}`)
                    toast.success('Transaction submitted successfully. Please wait for admin approval')

                    document.getElementById('bankpop-pup').click()
                    router('/user/dashboard')
                    setShowRazorpayModal(false);
                    setspinner(false)
                }).catch(err => {
                })


            }
            else {
                toast.error('please Upload the transaction slip or enter the transaction ID')
            }
        }
        if (shemData?.plan_title === "digital_silver_plan") {

            if (Transactionid || transfile) {

                setspinner(true)

                const formdata = new FormData()
                formdata.append('amount', clientamount)
                formdata.append('digital_plan_id', shemData?.id)
                formdata.append('transaction_id', Transactionid ? Transactionid : null)
                formdata.append('benificiar', benificid)
                formdata.append('payment_method', 'bank')
                formdata.append('uploads', transfile)

                SavedigitalSilverplan(formdata).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    // toast.success(`Payment successful from ${shemData?.name}`)
                    toast.success('Transaction submitted successfully. Please wait for admin approval')

                    document.getElementById('bankpop-pup').click()
                    router('/user/dashboard')
                    setShowRazorpayModal(false);
                    setspinner(false)
                }).catch(err => {
                })


            }
            else {
                toast.error('please Upload the transaction slip or enter the transaction ID')
            }
        }
        if (shemData?.plan_title === "gold_plant") {

            if (Transactionid || transfile) {

                setspinner(true)
                const formdata = new FormData()
                formdata.append('amount', clientamount)
                formdata.append('gold_plant_id', shemData?.id)
                formdata.append('transaction_id', Transactionid ? Transactionid : null)
                formdata.append('benificiar', benificid)
                formdata.append('payment_method', 'bank')
                formdata.append('uploads', transfile)

                SaveGoldplan(formdata).then(res => {
                    if (res?.error) {
                        return toast.error(res?.error ?? 'Somthing Went Wrong!')
                    }
                    // toast.success(`Payment successful from ${shemData?.name}`)
                    // toast.success('Transaction submitted successfully. Please wait for admin approval')
                    document.getElementById('bankpop-pup').click()
                    router('/user/dashboard')
                    setShowRazorpayModal(false);

                    setspinner(false)
                }).catch(err => {
                })


            }
            else {
                toast.error('please Upload the transaction slip or enter the transaction ID')
            }
        }

    }

    const screenshot = (e) => {
        setfile1(e.target.files[0]?.name)
        settransfile(e.target.files[0])
    }


    const getenroll = () => {
        Enroll_fun()
            .then((res) => {
                setEnroll_data(res?.data)
                setisLoading(false)
            })
            .catch((err) => {
                setisLoading(false)
            })
    }

    useEffect(() => {
        getenroll()
    }, [])



    //added 

    const upiId = "Vyapar.171813426519@hdfcbank";
    const phonumber = setting_data ? setting_data[0]?.phone : "8190059995"
    // const rawPhone = setting_data ? setting_data[0]?.phone : "8190059995";

    // const phonumber = rawPhone.replace(/^\+\d+\s*/, "").replace(/\D/g, "");

    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [copiedField, setCopiedField] = useState("");

    const handleCopy = (text, fieldKey) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                setCopiedField(fieldKey); // mark this field as copied
                // toast.success("Copied"); // show toast
                setTimeout(() => setCopiedField(""), 2000);
                setOpenSnackbar(true); /// reset after 2s
            })
            .catch((err) => console.error("Copy failed:", err));
    };

    const handleCloseSnackbar = (_, reason) => {
        if (reason === "clickaway") return;
        setOpenSnackbar(false);
    };
    const [showModal, setShowModal] = useState(false);
    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);
    const [previewUrl, setPreviewUrl] = useState(null);


    const PlanCard = ({ plan, route }) => {
        if (!plan) return null;
        return (
            // <div className="card h-100 shadow-sm border-1 " data-aos="zoom-in">
            //     <div className="card-body d-flex flex-column justify-content-between">
            //         <h5 className="fw-bold mb-3">{plan.name}</h5>
            //         <p className="mb-1 text-muted">
            //             Min Amount: <strong>₹{Number(plan.min_price).toLocaleString("en-IN")}</strong>
            //         </p>
            //         <p className="mb-3 text-muted">
            //             Max Amount: <strong>₹{Number(plan.max_price).toLocaleString("en-IN")}</strong>

            //         </p>
            //         <button className="btn w-100" style={{ backgroundColor: "#650020", color: "white" }} onClick={() => router(route)}>
            //             Pay Now
            //         </button>
            //     </div>

            // </div>
            <div
                className="card h-100 shadow-sm border-1 rounded-4 p-3"
                data-aos="zoom-in"
            //   style={ cursor: "pointer" }

            >
                <div className="card-body d-flex flex-column justify-content-between text-center">

                    {/* Row 1: Name, Withdraw, Weight */}
                    <div className="d-flex justify-content-between mb-3 align-items-center">
                        {/* Name */}
                        <div className="text-start flex-grow-1 me-2" style={{ minWidth: 0 }}>
                            <span className="text-muted small d-block">Name</span>
                            <p
                                className="fw-semibold text-success mb-0"
                                style={{
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                }}
                                title={plan?.users?.name || ""}
                            >
                                {plan?.users?.name || "-"}
                            </p>
                        </div>

                        {/* Withdraw */}
                        {/* <div className="text-center flex-shrink-0 me-2" style={{ width: "80px" }}>
        <span className="text-muted small d-block">Withdraw</span>
        <p className="fw-semibold text-success mb-0">
          {plan?.withdraw != null ? plan?.withdraw : "-"}
        </p>
      </div> */}

                        {/* Weight */}
                        <div className="text-center flex-shrink-0" style={{ width: "80px" }}>
                            <span className="text-muted small d-block">Weight</span>
                            <p className="fw-semibold text-success mb-0">
                                {plan?.purchase_transaction?.[0]?.gold_gram
                                    ? Number(plan?.purchase_transaction[0]?.gold_gram).toLocaleString("en-IN")
                                    : "-"} g
                            </p>
                        </div>
                    </div>

                    {/* Row 2: Amount, Withdraw Date */}
                    <div className="d-flex justify-content-between mb-4 align-items-center">
                        {/* Amount */}
                        <div className="text-start flex-grow-1 me-2" style={{ minWidth: 0 }}>
                            <span className="text-muted small d-block">Amount</span>
                            <p className="fw-semibold text-success mb-0">
                                ₹{Number(plan?.amount || 0).toLocaleString("en-IN")}
                            </p>
                        </div>

                        <div className="text-center flex-shrink-0 me-2" style={{ width: "80px" }}>
                            <span className="text-muted small d-block">Withdraw</span>
                            <p className="fw-semibold text-success mb-0">
                                {plan?.withdraw != null ? plan?.withdraw : "-"}
                            </p>
                        </div>

                    </div>
                    <div className="mb-2 text-center">
                        <span
                            className="badge fs-6"
                            style={{ backgroundColor: "#ffe6ec", color: "#650020" }}
                        >
                            2 Months Bonus
                        </span>
                    </div>
                    {/* Action Button */}
                    <button
                        className="btn w-100 rounded-pill fw-semibold"
                        style={{ backgroundColor: "#650020", color: "white" }}
                        onClick={() => router(route)}
                    >
                        Pay Now
                    </button>
                </div>
            </div>


            //         <div
            //             className="card h-100 shadow-sm border-1 rounded-4"
            //             data-aos="zoom-in"
            //         >
            //             <div className="card-body d-flex flex-column justify-content-between text-center">

            //                 {/* Plan Name */}
            //                 {/* <h5 className="fw-bold mb-3 text-dark">
            //   {plan?.saving_plan?.name}
            // </h5> */}

            //                 <div className="d-flex justify-content-between">

            //                     <div className="mb-2">
            //                         <span className="text-muted small">Name</span>
            //                         <p className="fw-small text-success mb-0">
            //                             {plan?.users?.name}
            //                         </p>
            //                     </div>



            //                     <div className="mb-4">
            //                         <span className="text-muted small">Withdraw</span>
            //                         <p className="fw-small mb-0">
            //                             {plan?.withdraw_date != null ? plan?.withdraw_date
            //                                 : "-"}
            //                         </p>
            //                     </div>
            //                 </div>

            //                 <div className="d-flex justify-content-between">



            //                     <div className="mb-2">
            //                         <span className="text-muted small">Amount</span>
            //                         <p className="fw-small text-success mb-0">
            //                             ₹{Number(plan?.amount).toLocaleString("en-IN")}
            //                         </p>
            //                     </div>


            //                     <div className="mb-2">
            //                         <span className="text-muted small">Weight</span>
            //                         <p className="fw-small text-success mb-0">
            //                             {plan?.purchase_transaction[0]?.gold_gram ? Number(plan?.purchase_transaction[0]?.gold_gram).toLocaleString("en-IN") : "-"}
            //                         </p>
            //                     </div>


            //                     <div className="mb-4">
            //                         <span className="text-muted small">Withdraw Date</span>
            //                         <p className="fw-small mb-0">
            // {plan?.withdraw_date != null ? plan?.withdraw_date
            //     : "-"}
            //                         </p>
            //                     </div>
            //                 </div>

            //                 <button
            //                     className="btn w-100 rounded-pill fw-semibold"
            //                     style={{ backgroundColor: "#650020", color: "white" }}
            //                     onClick={() => router(route)}
            //                 >
            //                     Details
            //                 </button>
            //             </div>
            //         </div>

        );
    };

    const isAnyActive =
        (Shcudle?.active_count > 0) && chitPlanData?.length > 0;
    // (digita_shedule?.active_count > 0) ||
    // (digital_silver?.active_count > 0) ||
    // (gold_shedule?.active_count > 0);




    return (<>
        <section>
            <button type="button" className="d-none" data-bs-toggle="modal" id='openPriceplanpopu' data-bs-target="#razarpaypopup"> sssdsdsd</button>

            <div className="modal fade" id="razarpaypopup" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="razarpaypopupLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className={shemData?.plan_title === "gold_plant" ? 'modal-content paybox schemecard' : 'modal-content schemecard'}>
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 schemename" id="razarpaypopupLabel">{shemData?.plan_title === "digital_plan" ? `${shemData?.name}(Cash Back)` : shemData?.plan_title === "gold_plant" ? `${shemData?.name}(Monthly Rental)` : shemData?.name}</h1>

                            <button type="button" className="btn-close" id='closepriceModal' data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('Rupees').value = null; setprice(null) }} ></button>
                        </div>
                        <div className="modal-body">
                            <form ref={fromsubmit} onSubmit={(e) => {
                                e.preventDefault();

                                if (!token) {
                                    document.getElementById('closepriceModal')?.click();
                                    document.getElementById('openRegistermodal')?.click();
                                    return;
                                }

                                if (!price) {
                                    toast.error("Please Enter Price!")
                                } else if (shemData?.plan_title === "gold_plant") {
                                    const amount = parseFloat(price) + parseFloat(((price * 6 / 100) + (price * 3 / 100)))

                                    if (parseInt(price) < parseInt(shemData?.min_price)) {
                                        toast.error(`Minmum Amount is ${shemData?.min_price}!`)
                                    } else if (parseInt(price) > shemData?.max_price) {
                                        toast.error(`Maximum Amount is ${shemData?.max_price}!`)
                                    } else if (checked !== true) {
                                        toast.error('Please Agree Terms & conditions')
                                    }
                                    else {
                                        document.getElementById('closepriceModal')?.click();
                                        document.getElementById('payment-pup').click()
                                        document.getElementById('inlineRadio1').checked = false;
                                        document.getElementById('inlineRadio2').checked = false;
                                        document.getElementById('inlineRadio3').checked = false;
                                        document.getElementById('Rupees').value = null
                                        setprocess_type();
                                        setclientamount(price)
                                        setChargeAmt(amount)
                                        setBenifitid(benificid)

                                    }
                                } else {
                                    if (parseInt(price) < parseInt(shemData?.min_price)) {
                                        toast.error(`Minmum Amount is ${shemData?.min_price}!`)
                                    } else if (parseInt(price) > shemData?.max_price) {
                                        toast.error(`Maximum Amount is ${shemData?.max_price}!`)
                                    } else if (checked !== true) {
                                        toast.error('Please Agree Terms & conditions')
                                    }
                                    else {
                                        document.getElementById('closepriceModal')?.click();
                                        document.getElementById('payment-pup').click()
                                        document.getElementById('inlineRadio1').checked = false;
                                        document.getElementById('inlineRadio2').checked = false;
                                        document.getElementById('inlineRadio3').checked = false;
                                        setprocess_type();
                                        setclientamount(price)

                                    }
                                }

                            }}>

                                {/* {
                                    shemData?.plan_title === "digital_plan" ? '' : (
                                        <div className="mb-3" style={{overflow:"hidden"}}>
                                            <label className="col-form-label fw-bold">Beneficiaries</label>
                                            <select className="form-select " onChange={(e) => { setbenificid(e.target.value) }} aria-label="ben" >
                                                <option value={''} >{detail_info?.name}</option>
                                                {
                                                    benfic.map((data, i) => (
                                                        <option value={data?.id} key={i}>{data.name}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    )
                                } */}


                                {shemData?.plan_title !== "digital_plan" && (
                                    <div className="mb-3">
                                        <label className="col-form-label fw-bold">Beneficiaries</label>
                                        <Select
                                            options={[
                                                { value: '', label: detail_info?.name },
                                                ...benfic.map(b => ({ value: b.id, label: b.name }))
                                            ]}
                                            defaultValue={{ value: '', label: detail_info?.name }}
                                            onChange={(selected) => setbenificid(selected.value)}
                                            menuPortalTarget={document.body} // ensures dropdown is on top
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                )}


                                <div className="mb-3">
                                    <label htmlFor="Rupees" className="form-label"><span className='fw-bold'>Price</span> <small className='text-danger'>{`(Minimum Amount ${shemData?.min_price} to Maximum Amount ${shemData?.max_price})`}</small></label>
                                    <input type="text" maxLength={10} value={price} onChange={(e) => setprice(e.target.value?.replace(/[^0-9]/g, ""))} className="form-control p-3" id="Rupees" placeholder={`Ex: ${shemData?.min_price}`} />
                                    {/* {shemData?.plan_title === "gold_plant" && price ? <span className='text-color'>Deduct Gst & Service tax  : {(price - ((price * 6 / 100) + (price * 3 / 100))).toFixed(2)}</span> : ''} */}
                                    {shemData?.plan_title === "gold_plant" ? (<><p className='text-color m-0'>VAT charge : {price ? (price * 3 / 100).toFixed(2) : 0}</p>
                                        <p className='text-color m-0'>Service charge : {price ? (price * 6 / 100).toFixed(2) : 0}</p>
                                        <p className='text-color m-0'>VAT + Service  : {price ? ((price * 6 / 100) + (price * 3 / 100)).toFixed(2) : 0}</p>
                                        <p className='text-color m-0'>Total Amount   : {price ? (parseFloat(price) + ((price * 6 / 100) + (price * 3 / 100))) : 0}</p>
                                    </>) : ''}
                                </div>
                                <div className="mb-3">
                                    <input className="form-check-input" type="checkbox" value="" id="agreecheck" onChange={(e) => { setchecked(e.target.checked) }} />

                                    <label className="form-check-label ms-2" htmlFor="flexCheckDefault">
                                        {/* I  agree {
                                            footerpage ? (<a href={`pages/${footerpage[0]?.slug}`} target='_blank'><span className='termsborder'>Terms and Condition</span></a>) : (<span className='termsborder'>Terms and Condition</span>)
                                        } */}
                                        I agree <a href={`pages/${shemData?.page?.slug}`} target='_blank'><span className='termsborder'>Terms and Condition</span></a>
                                    </label>
                                </div>

                                <div className="mb-3">
                                    <div className="update-profile  mx-2">
                                        <button className="text-white" type="submit">Continue</button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
            {isAnyActive && token && (
                <div className='px-5'>
                    <div className='d-flex justify-content-center w-100 text-center titsksd mb-3'>
                        <div>
                            <div data-aos="fade-right">
                                <img src='/assets/images/shpas.png' />
                            </div>
                            <div data-aos="fade-left">
                                <h2 className='fw-bold'>Chit Scheme Active Plans</h2>
                            </div>
                        </div>
                    </div>
                    {chitPlanData?.length > 5 && token ? (
                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={16}
                            slidesPerView={4}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            loop={chitPlanData?.length >= 8}
                            className="plan-swiper"
                            breakpoints={{
                                0: { slidesPerView: 1.2 },
                                576: { slidesPerView: 2 },
                                768: { slidesPerView: 3 },
                                992: { slidesPerView: 4 },
                            }}
                        >
                            {chitPlanData.map((chit) => (
                                <SwiperSlide key={chit.id}>
                                    <PlanCard
                                        plan={chit}
                                        route="/user/chit-jewels"
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    ) : (
                        <div className="row g-4 my-2 justify-content-center">
                            {chitPlanData.map((chit) => (
                                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3" key={chit.id}>
                                    <PlanCard
                                        plan={chit}
                                        route="/user/chit-jewels"
                                    />
                                </div>
                            ))}
                        </div>
                    )}



                </div>
            )}






            <div className='px-5'>
                <div className='d-flex justify-content-center w-100 text-center titsksd mb-3'>
                    <div>
                        <div data-aos="fade-right">
                            <img src='/assets/images/shpas.png' />
                        </div>
                        <div data-aos="fade-left">
                            <h2 className='fw-bold'>Quick overview of schemes</h2>
                        </div>
                    </div>
                </div>

                {isLoading ?
                    (<>
                        <div className=' row  '>
                            {
                                Array.from({ length: 4 }).map((_, i) => (
                                    <div className='col-md-6  col-lg-3 col-md-6 col-sm-12 mt-lg-0 mt-sm-3' key={i}>
                                        <div className='d-sm-flex justify-content-sm-center d-md-block  justify-content-md-center d-none d-sm-block '>
                                            <div className='schema_main  '>
                                                <div className='top'>

                                                    <img alt='' src='/assets/images/Scheme 3.png' className='log mb-3' />
                                                    <h4 className=' fw-bold pb-2'> <Shimmer width={180} height={30} /></h4>
                                                </div>
                                                <div className='schema'>
                                                    <div className='d-flex gap-2 align-items-center mb-3'>

                                                        <Shimmer width={250} height={22} className='rounded' />
                                                    </div>
                                                    <div className='d-flex gap-2 align-items-center mb-3'>

                                                        <Shimmer width={250} height={22} className='rounded' />
                                                    </div>
                                                    <div className='d-flex gap-2 align-items-center mb-3'>

                                                        <Shimmer width={250} height={22} className='rounded' />
                                                    </div>
                                                    <div className='d-flex gap-2 align-items-center mb-3'>

                                                        <Shimmer width={250} height={22} className='rounded' />
                                                    </div>
                                                    <div className='d-flex gap-2 align-items-center mb-3 '>

                                                        <Shimmer width={250} height={22} className='rounded' />
                                                    </div>

                                                    <div className='schemebtn-3'>
                                                        <Shimmer width={177} height={49} className='rounded-5' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='d-block d-sm-none '>
                            {
                                Array.from({ length: 3 }).map((_, i) => (
                                    <div className='my-2' key={i}>
                                        <Shimmer className='rounded w-100' height={100} width={100} />
                                    </div>

                                ))
                            }

                        </div>
                    </>)
                    :
                    <div className='row'>
                        {
                            scheme_list ?
                                (<>
                                    <div className='col-md-6 col-lg-3 col-sm-12 chkclick mb-3' >
                                        <div data-aos="fade-up" className='scheme-mbbox'>
                                            {/* <div className='schema_main'  >
                                            <div className='top_active act1'>
                                                <div className='benefits_flx'>
                                                <img alt='' src='/assets/images/green.png' className='log' />
                                                <div>
                                                    <button id="blinking-button">Benefits 25% Extra Savings</button>
                                                </div>
                                                </div>

                                                <h4 className=' fw-bold pb-2 mt-4'>{scheme_list?.name}</h4>
                                            </div>
                                            <div className='schema schemelen'>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Lock in Period </p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>{scheme_list?.plan_tenure ?? 0} Months</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Punctuality Bonus</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>{scheme_list?.punctuality_bonus ?? 0} %</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Profit Rate </p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>{scheme_list?.bonus ?? 0} %</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Minimum</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>₹ {scheme_list?.min_price ?? 0}</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Maximum</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>₹ {scheme_list?.max_price ?? 0}</p>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className='schema schemebtn-1'>
                                                <button type='button' onClick={() => {
                                                    if (detail_info && token) {
                                                        setSchemaData(scheme_list);
                                                        setprice();
                                                        document.getElementById('agreecheck').checked = false;
                                                        document.getElementById("openPriceplanpopu")?.click();
                                                        setchecked(false)

                                                    } else {
                                                        setSchemaData(scheme_list);
                                                        setprice();
                                                        localStorage.setItem("pendingScheme", JSON.stringify(scheme_list));
                                                        document.getElementById("loginPopupopen")?.click();
                                                        document.getElementById('agreecheck').checked = false;
                                                        setchecked(false)
                                                        setopenSchemes(true);

                                                    }
                                                }} className='btn d-flex align-items-center gap-2'>Buy scheme <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                </button>



                                                <div className='details'>
                                                    { token && detail_info ?
                                                    <span onClick={() => router(`/scheme-detail/${scheme_list.plan_title}`)} className='btn'>
                                                        Scheme Details
                                                    </span>
                                                     : ''}
                                                </div>

                                            </div>
                                        </div> */}
                                            <div className='quick_img'>
                                                <div className='plan_img'>
                                                    <img alt='' src={scheme_list?.frontend_banner || '/assets/images/chit_saving_plan.png'} className='log' />
                                                </div>
                                                <div className='schema schemebtn-1 '>
                                                    <button type='button' onClick={() => {
                                                        if (detail_info && token) {
                                                            setSchemaData(scheme_list);
                                                            setprice();
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("openPriceplanpopu")?.click();
                                                            setchecked(false)

                                                        } else {
                                                            setSchemaData(scheme_list);
                                                            setprice();
                                                            localStorage.setItem("pendingScheme", JSON.stringify(scheme_list));
                                                            document.getElementById("loginPopupopen")?.click();
                                                            document.getElementById('agreecheck').checked = false;
                                                            setchecked(false)
                                                            setopenSchemes(true);

                                                        }
                                                    }} className='btn d-flex align-items-center gap-2'>Buy scheme <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                    </button>



                                                    <div className='details'>
                                                        {token && detail_info ?
                                                            <span onClick={() => router(`/scheme-detail/${scheme_list.plan_title}`)} className='btn'>
                                                                Scheme Details
                                                            </span>
                                                            : ''}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    {/* mobile-view */}

                                    {/* <div className='d-block mb-scheme-box  d-sm-none my-2'>
                                    <div className="accordion accordion-flush" id="accordionFlushExample">
                                        <div className="accordion-item mb-schem">
                                            <h2 className="accordion-header mb-schem-head" id="flush-headingOne">
                                                <div className="accordion-button collapsed d-block" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                    <div className='mb-sch-img'>
                                                        <img alt='' src='/assets/images/green.png' className='log' />
                                                    </div>
                                                    <div className='mb-sch-name d-flex align-items-center justify-content-between'>
                                                        <h5 className=' fw-bold pb-2'>{scheme_list?.name}</h5>
                                                        <h6><ChevronDown /></h6>
                                                    </div>
                                                </div>
                                            </h2>
                                            <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                <div className='schema schemelen'>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Lock in Period </p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>{scheme_list?.plan_tenure ?? 0} Months</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Punctuality Bonus</p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>{scheme_list?.punctuality_bonus ?? 0} %</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Profit Rate </p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>{scheme_list?.bonus ?? 0} %</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Minimum</p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>₹ {scheme_list?.min_price ?? 0}</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Maximum</p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>₹ {scheme_list?.max_price ?? 0}</p>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div className='schema schemebtn-1'>
                                                    <button type='button' onClick={() => {
                                                        if (detail_info && token) {
                                                            setSchemaData(scheme_list);
                                                            setprice();
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("openPriceplanpopu")?.click();
                                                            setchecked(false)

                                                        } else {
                                                            setSchemaData(scheme_list);
                                                            setprice();
                                                            document.getElementById("loginPopupopen")?.click();
                                                            document.getElementById('agreecheck').checked = false;
                                                            setchecked(false)
                                                            setopenSchemes(true);

                                                        }
                                                    }} className='btn d-flex align-items-center gap-2'>Buy scheme <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                    </button>

                                                    <div className='details'>
                                                    { token && detail_info ?
                                                    <span onClick={() => router(`/scheme-detail/${scheme_list.plan_title}`)} className='btn'>
                                                        Scheme Details
                                                    </span>
                                                     : ''}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                </>)
                                : ""
                        }

                        {
                            DigitaScheme ? (
                                <>
                                    <div className=' my-sm-4 my-md-0 col-md-6 col-lg-3 col-sm-12 chkclick fade-up mb-3' >
                                        <div data-aos="fade-up" className='scheme-mbbox'>
                                            {/* <div className='schema_main'>
                                            <div className='top_active'>
                                            <div className='benefits_flx'>
                                                <img alt='' src='/assets/images/green.png' className='log' />
                                                <div>
                                                    <button id="blinking-button">Cashback Plan Silver</button>
                                                </div>
                                                </div>
                                                <h4 className=' fw-bold pb-2 mt-4'>{DigitaScheme?.name}</h4>
                                            </div>
                                            <div className='schema schemelen'>
                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Lock in Period</p>
                                                    </div>

                                                    <div>

                                                        <p className='mb-0'>3 Years</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Active Plan</p>
                                                    </div>

                                                    <div>

                                                        <p className='mb-0'>1 (gm)</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Minimum</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>₹ {DigitaScheme?.min_price ?? 0}</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Maximum</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>₹ {DigitaScheme?.max_price ?? 0}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className=' schema schemebtn-1'>
                                                <button type='button' onClick={() => {
                                                    if (!detail_info && !token) {
                                                        setSchemaData(DigitaScheme);
                                                        setchecked(false)
                                                        document.getElementById('agreecheck').checked = false;
                                                        document.getElementById("loginPopupopen")?.click();

                                                    }
                                                    else if (DigitaScheme?.cancel_status === 0) {
                                                        toast.error('This Scheme already purchased')
                                                    }
                                                    else {
                                                        setSchemaData(DigitaScheme);
                                                        setchecked(false);
                                                        document.getElementById('agreecheck').checked = false;
                                                        document.getElementById("openPriceplanpopu")?.click();
                                                    }
                                                }}

                                                    className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                </button>

                                                <div className='details'>
                                                    { token && detail_info ?
                                                    <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
                                                        Scheme Details
                                                    </span>
                                                     : ''}
                                                </div>
                                            </div>
                                        </div> */}
                                            <div className='quick_img'>
                                                <div className='plan_img'>
                                                    <img alt='' src={DigitaScheme?.frontend_banner || '/assets/images/digital_gold_sip.png'} className='log' />
                                                </div>
                                                <div className=' schema schemebtn-1'>
                                                    <button type='button' onClick={() => {
                                                        if (!detail_info && !token) {
                                                            setSchemaData(DigitaScheme);
                                                            setchecked(false)
                                                            localStorage.setItem("pendingScheme", JSON.stringify(DigitaScheme));
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("loginPopupopen")?.click();

                                                        }
                                                        else if (DigitaScheme?.cancel_status === 0) {
                                                            toast.error('This Scheme already purchased')
                                                            router("/user/digital-gold")
                                                        }
                                                        else {
                                                            setSchemaData(DigitaScheme);
                                                            setchecked(false);
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("openPriceplanpopu")?.click();
                                                        }
                                                    }}

                                                        className='btn d-flex align-items-center gap-2'> Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                    </button>

                                                    <div className='details'>
                                                        {token && detail_info ?
                                                            <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
                                                                Scheme Details
                                                            </span>
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* mobile-view */}

                                    {/* <div className='d-block mb-scheme-box  d-sm-none my-2'>
                                    <div className="accordion accordion-flush" id="accordionFlushExample">
                                        <div className="accordion-item  mb-schem">
                                            <h2 className="accordion-header mb-schem-head" id="flush-headingOne">
                                                <div className="accordion-button collapsed d-block" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                    <div className='mb-sch-img'>
                                                        <img alt='' src='/assets/images/green.png' className='log' />
                                                    </div>
                                                    <div className='mb-sch-name d-flex align-items-center justify-content-between'>
                                                        <h5 className=' fw-bold pb-2'>{DigitaScheme?.name}</h5>
                                                        <h6><ChevronDown /></h6>
                                                    </div>
                                                </div>
                                            </h2>
                                            <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                <div className='schema schemelen'>
                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Lock in Period</p>
                                                        </div>

                                                        <div>

                                                            <p className='mb-0'>3 Years</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Active Plan</p>
                                                        </div>

                                                        <div>

                                                            <p className='mb-0'>1 (gm)</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Minimum</p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>₹ {DigitaScheme?.min_price ?? 0}</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Maximum</p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>₹ {DigitaScheme?.max_price ?? 0}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className=' schema schemebtn-1'>
                                                    <button type='button' onClick={() => {
                                                        if (!detail_info && !token) {
                                                            setSchemaData(DigitaScheme);
                                                            setchecked(false)
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("loginPopupopen")?.click();

                                                        }
                                                        else if (DigitaScheme?.cancel_status === 0) {
                                                            toast.error('This Scheme already purchased')
                                                        }
                                                        else {
                                                            setSchemaData(DigitaScheme);
                                                            setchecked(false);
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("openPriceplanpopu")?.click();
                                                        }
                                                    }}

                                                        className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                    </button>

                                                    <div className='details'>
                                                        { token && detail_info ?
                                                        <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
                                                            Scheme Details
                                                        </span>
                                                        : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                </>
                            )
                                : ''
                        }



                        {
                            Goldplant_data ? (<>
                                <div className='col-md-6 col-lg-3 col-sm-12 chkclick fade-up mb-3' >
                                    <div data-aos="fade-up" className='scheme-mbbox'>
                                        {/* <div className='schema_main'>
                                        <div className='top_active'>
                                        <div className='benefits_flx'>
                                            <img alt='' src='/assets/images/green.png' className='log' />
                                            <div>
                                                <button id="blinking-button">Monthly Yield Gold</button>
                                            </div>
                                            </div>
                                            <h4 className=' fw-bold pb-2 mt-4'>{Goldplant_data?.name}</h4>
                                        </div>
                                        <div className='schema schemelen'>
                                            <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                <div className="d-flex gap-2  align-items-center">
                                                    <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                    <p className='mb-0'>Principal Returns    After</p>
                                                </div>

                                                <div>
                                                    <p className='mb-0'>{Goldplant_data?.returns_year ?? 0} year</p>
                                                </div>
                                            </div>

                                            <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                <div className="d-flex gap-2  align-items-center">
                                                    <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                    <p className='mb-0'>Assured Returns</p>
                                                </div>

                                                <div>
                                                    <p className='mb-0'>{Goldplant_data?.payout_term ?? 0} year</p>
                                                </div>
                                            </div>

                                            <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                <div className="d-flex gap-2  align-items-center">
                                                    <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                    <p className='mb-0'>Minimum</p>
                                                </div>

                                                <div>
                                                    <p className='mb-0'>₹ {Goldplant_data?.min_price ?? 0}</p>
                                                </div>
                                            </div>

                                            <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                <div className="d-flex gap-2  align-items-center">
                                                    <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                    <p className='mb-0'>Maximum</p>
                                                </div>

                                                <div>
                                                    <p className='mb-0'>₹ {Goldplant_data?.max_price ?? 0}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className=' schema schemebtn-1'>
                                            <button type='button' onClick={() => {
                                                if (detail_info && token) {
                                                    setSchemaData(Goldplant_data);
                                                    document.getElementById('agreecheck').checked = false;
                                                    setchecked(false)
                                                    document.getElementById("openPriceplanpopu")?.click();
                                                } else {
                                                    setSchemaData(Goldplant_data);
                                                    document.getElementById('agreecheck').checked = false;
                                                    setchecked(false)
                                                    document.getElementById("loginPopupopen")?.click();
                                                    setopenSchemes(true);
                                                }
                                            }} className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                            </button>

                                            <div className='details'>
                                                    { token && detail_info ?
                                                    <span onClick={() => router(`/scheme-detail/${Goldplant_data.plan_title}`)} className='btn'>
                                                        Scheme Details
                                                    </span>
                                                     : ''}
                                            </div>
                                        </div>
                                    </div> */}
                                        <div className='quick_img'>
                                            <div className='plan_img'>
                                                <img alt='' src={Goldplant_data?.frontend_banner || '/assets/images/gold_plant_scheme.png'} className='log' />
                                            </div>
                                            <div className=' schema schemebtn-1'>
                                                <button type='button' onClick={() => {
                                                    if (detail_info && token) {
                                                        setSchemaData(Goldplant_data);
                                                        document.getElementById('agreecheck').checked = false;
                                                        setchecked(false)
                                                        document.getElementById("openPriceplanpopu")?.click();
                                                    } else {
                                                        setSchemaData(Goldplant_data);
                                                        document.getElementById('agreecheck').checked = false;
                                                        setchecked(false)
                                                        localStorage.setItem("pendingScheme", JSON.stringify(Goldplant_data));
                                                        document.getElementById("loginPopupopen")?.click();
                                                        setopenSchemes(true);
                                                    }


                                                }} className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                </button>

                                                <div className='details'>
                                                    {token && detail_info ?
                                                        <span onClick={() => router(`/scheme-detail/${Goldplant_data.plan_title}`)} className='btn'>
                                                            Scheme Details
                                                        </span>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* mobile-view */}

                                {/* <div className='d-block mb-scheme-box  d-sm-none my-2'>
                                <div className="accordion accordion-flush" id="accordionFlushExample">
                                    <div className="accordion-item mb-schem">
                                        <h2 className="accordion-header mb-schem-head" id="flush-headingOne">
                                            <div className="accordion-button collapsed d-block" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                <div className='mb-sch-img'>
                                                    <img alt='' src='/assets/images/green.png' className='log' />
                                                </div>
                                                <div className='mb-sch-name d-flex align-items-center justify-content-between'>
                                                    <h5 className=' fw-bold pb-2'>{Goldplant_data?.name}</h5>
                                                    <h6><ChevronDown /></h6>
                                                </div>
                                            </div>
                                        </h2>
                                        <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                                            <div className='schema schemelen'>
                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Principal Returns After</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>{Goldplant_data?.returns_year ?? 0} year</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Assured Returns</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>{Goldplant_data?.payout_term ?? 0} year</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Minimum</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>₹ {Goldplant_data?.min_price ?? 0}</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Maximum</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>₹ {Goldplant_data?.max_price ?? 0}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className=' schema schemebtn-1'>
                                                <button type='button' onClick={() => {
                                                    if (detail_info && token) {
                                                        setSchemaData(Goldplant_data);
                                                        document.getElementById('agreecheck').checked = false;
                                                        setchecked(false)
                                                        document.getElementById("openPriceplanpopu")?.click();
                                                    } else {
                                                        setSchemaData(Goldplant_data);
                                                        document.getElementById('agreecheck').checked = false;
                                                        setchecked(false)
                                                        document.getElementById("loginPopupopen")?.click();
                                                        setopenSchemes(true);
                                                    }
                                                }} className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                </button>

                                                <div className='details'>
                                                    { token && detail_info ?
                                                    <span onClick={() => router(`/scheme-detail/${Goldplant_data.plan_title}`)} className='btn'>
                                                        Scheme Details
                                                    </span>
                                                     : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            </>) : ''
                        }


                        {
                            digitalSilverPlan ? (
                                <>
                                    <div className=' my-sm-4 my-md-0 col-md-6 col-lg-3 col-sm-12 chkclick fade-up mb-3' >
                                        
                                        <div data-aos="fade-up" className='scheme-mbbox'>
                                            {/* <div className='schema_main'>
                                            <div className='top_active'>
                                            <div className='benefits_flx'>
                                                <img alt='' src='/assets/images/green.png' className='log' />
                                                <div>
                                                    <button id="blinking-button">Cashback Plan Silver</button>
                                                </div>
                                                </div>
                                                <h4 className=' fw-bold pb-2 mt-4'>{DigitaScheme?.name}</h4>
                                            </div>
                                            <div className='schema schemelen'>
                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Lock in Period</p>
                                                    </div>

                                                    <div>

                                                        <p className='mb-0'>3 Years</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Active Plan</p>
                                                    </div>

                                                    <div>

                                                        <p className='mb-0'>1 (gm)</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Minimum</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>₹ {DigitaScheme?.min_price ?? 0}</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                    <div className="d-flex gap-2  align-items-center">
                                                        <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                        <p className='mb-0'>Maximum</p>
                                                    </div>

                                                    <div>
                                                        <p className='mb-0'>₹ {DigitaScheme?.max_price ?? 0}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className=' schema schemebtn-1'>
                                                <button type='button' onClick={() => {
                                                    if (!detail_info && !token) {
                                                        setSchemaData(DigitaScheme);
                                                        setchecked(false)
                                                        document.getElementById('agreecheck').checked = false;
                                                        document.getElementById("loginPopupopen")?.click();

                                                    }
                                                    else if (DigitaScheme?.cancel_status === 0) {
                                                        toast.error('This Scheme already purchased')
                                                    }
                                                    else {
                                                        setSchemaData(DigitaScheme);
                                                        setchecked(false);
                                                        document.getElementById('agreecheck').checked = false;
                                                        document.getElementById("openPriceplanpopu")?.click();
                                                    }
                                                }}

                                                    className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                </button>

                                                <div className='details'>
                                                    { token && detail_info ?
                                                    <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
                                                        Scheme Details
                                                    </span>
                                                     : ''}
                                                </div>
                                            </div>
                                        </div> */}
                                            <div className='quick_img'>
                                                <div className='plan_img'>
                                                    <img alt='' src={digitalSilverPlan?.frontend_banner || '/assets/images/digital_saving_plan_2.png'} className='log' />
                                                </div>
                                                <div className=' schema schemebtn-1'>
                                                    <button type='button' onClick={() => {
                                                        if (!detail_info && !token) {
                                                            setSchemaData(digitalSilverPlan);
                                                            setchecked(false)
                                                            localStorage.setItem("pendingScheme", JSON.stringify(digitalSilverPlan));
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("loginPopupopen")?.click();

                                                        }
                                                        else if (digitalSilverPlan?.cancel_status === 0) {
                                                            toast.error('This Scheme already purchased')
                                                            router("/user/digital-silver")
                                                        }
                                                        else {
                                                            setSchemaData(digitalSilverPlan);
                                                            setchecked(false);
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("openPriceplanpopu")?.click();
                                                        }
                                                    }}

                                                        className='btn d-flex align-items-center gap-2'> Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                    </button>

                                                    <div className='details'>
                                                        {token && detail_info ?
                                                            <span onClick={() => router(`/scheme-detail/${digitalSilverPlan.plan_title}`)} className='btn'>
                                                                Scheme Details
                                                            </span>
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* mobile-view */}

                                    {/* <div className='d-block mb-scheme-box  d-sm-none my-2'>
                                    <div className="accordion accordion-flush" id="accordionFlushExample">
                                        <div className="accordion-item  mb-schem">
                                            <h2 className="accordion-header mb-schem-head" id="flush-headingOne">
                                                <div className="accordion-button collapsed d-block" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                    <div className='mb-sch-img'>
                                                        <img alt='' src='/assets/images/green.png' className='log' />
                                                    </div>
                                                    <div className='mb-sch-name d-flex align-items-center justify-content-between'>
                                                        <h5 className=' fw-bold pb-2'>{DigitaScheme?.name}</h5>
                                                        <h6><ChevronDown /></h6>
                                                    </div>
                                                </div>
                                            </h2>
                                            <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                <div className='schema schemelen'>
                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Lock in Period</p>
                                                        </div>

                                                        <div>

                                                            <p className='mb-0'>3 Years</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Active Plan</p>
                                                        </div>

                                                        <div>

                                                            <p className='mb-0'>1 (gm)</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Minimum</p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>₹ {DigitaScheme?.min_price ?? 0}</p>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-2 justify-content-between align-items-center mb-3'>
                                                        <div className="d-flex gap-2  align-items-center">
                                                            <img alt='' src='/assets/iocns/Tick.png' className='' />
                                                            <p className='mb-0'>Maximum</p>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>₹ {DigitaScheme?.max_price ?? 0}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className=' schema schemebtn-1'>
                                                    <button type='button' onClick={() => {
                                                        if (!detail_info && !token) {
                                                            setSchemaData(DigitaScheme);
                                                            setchecked(false)
                                                            localStorage.setItem("pendingScheme", JSON.stringify(DigitaScheme));
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("loginPopupopen")?.click();

                                                        }
                                                        else if (DigitaScheme?.cancel_status === 0) {
                                                            toast.error('This Scheme already purchased')
                                                        }
                                                        else {
                                                            setSchemaData(DigitaScheme);
                                                            setchecked(false);
                                                            document.getElementById('agreecheck').checked = false;
                                                            document.getElementById("openPriceplanpopu")?.click();
                                                        }
                                                    }}

                                                        className='btn d-flex align-items-center gap-2'>Buy scheme  <img alt='' src='/assets/iocns/Arrow right.png' className='' />
                                                    </button>

                                                    <div className='details'>
                                                        { token && detail_info ?
                                                        <span onClick={() => router(`/scheme-detail/${DigitaScheme.plan_title}`)} className='btn'>
                                                            Scheme Details
                                                        </span>
                                                        : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                </>
                            )
                                : ''
                        }
                    </div>
                }
            </div>


        </section>





        {token && detail_info ? <section className='schema2' >



            <div className='container'>
                {/* <div className='d-flex justify-content-center w-100 text-center titsksd mb-3'>
                    <div>
                        <div data-aos="fade-up-right">
                            <img src='/assets/images/shpas.png' alt='' />
                        </div>
                        <div data-aos="fade-up-left">
                            <h2 className='fw-bold mb-0'>Returns with Gold Investment Leaf </h2>
                            <h2 className='fw-bold mb-4'>(SIP Scheme)</h2>
                        </div>
                    </div>
                </div>
                <div className='mb-3'>
                    <div data-aos="fade-up">
                        <div className='d-flex schematable gap-2'>
                            <div>
                                <div className='mb-2 leaft leaft-head text-center G1'>
                                    <h5 className='text-light'>Gold Investment Leaf Scheme</h5>
                                </div>

                                <div className='mb-2 leaft text-center  G2'>
                                    <h5>3 months (0-90 days)</h5>
                                </div>

                                <div className='mb-2 leaft text-center G3'>
                                    <h5>6 months (90-180 days)</h5>
                                </div>

                                <div className='mb-2 leaft text-center G4'>
                                    <h5>9 months (180 - 270 days)</h5>
                                </div>

                                <div className='mb-2 leaft text-center G5'>
                                    <h5>12 months (270 - 360 days)</h5>
                                </div>

                                <div className='mb-2 leaft text-center G6'>
                                    <h5>2nd Year</h5>
                                </div>

                                <div className='mb-2 leaft text-center G7'>
                                    <h5>3rd Year</h5>
                                </div>
                            </div>

                            <div>
                                <div className='mb-2 leaft  leaft-head  text-center C1'>
                                    <h5>GreenHeap Gold approx. (1,000 assured)</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2 '>
                                    <h5>(0.25% x 3m) Rs. 7.50</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(0.5% X 6m) Rs. 30.00</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(0.75% X 9m) Rs. 67.50</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(1% X 12m) Rs. 120.00</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(1% X 24m) Rs. 240.00</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(1% X 36m) Rs. 360.00</h5>
                                </div>
                            </div>

                            <div>
                                <div className='mb-2 leaft  leaft-head text-center C1'>
                                    <h5>GreenHeap Silver Bonus</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(9.6% per annum For 3m) Rs. 24.00</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(10% per annum For 6m) Rs. 50.00</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(12% per annum For 9m) Rs. 90.00</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(14% per annum For 12m) Rs. 140.00</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(18% per annum For 24m) Rs. 360.00</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(20% per annum For 36m) Rs. 600.00</h5>
                                </div>
                            </div>

                            <div>
                                <div className='mb-2 leaft  leaft-head text-center C1'>
                                    <h5>GreenHeap Gold + Silver Bonus</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(7.50 + 24.00) Rs. 31.5</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(30.00 + 50.00) Rs. 80</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(67.50 + 90.00) Rs. 157.5</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(120.00 + 140.00) Rs. 260</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(240.00 + 360.00) Rs. 600</h5>
                                </div>

                                <div className='mb-2 leaft text-center C2'>
                                    <h5>(360.00 + 600.00) Rs. 960</h5>
                                </div>
                            </div>

                            <div>
                                <div className='mb-2 leaft text-center px-lg-1 leaft-head F1'>
                                    <h5 className='text-light m-0'>Sip Total Returns</h5>
                                    <h5 className='text-light'>(Cash Back)</h5>
                                </div>

                                <div className='mb-2 leaft text-center F2'>
                                    <h5>31.5</h5>
                                </div>

                                <div className='mb-2 leaft text-center F3'>
                                    <h5>80</h5>
                                </div>

                                <div className='mb-2 leaft text-center F4'>
                                    <h5>157.5</h5>
                                </div>

                                <div className='mb-2 leaft text-center F5'>
                                    <h5>260</h5>
                                </div>

                                <div className='mb-2 leaft text-center F6'>
                                    <h5>600</h5>
                                </div>

                                <div className='mb-2 leaft text-center F7'>
                                    <h5>960</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                </div> */}
                <div data-aos="fade-left">
                    <div className='text-center'>
                        <h5 className='terms-text'>
                            <span className='' style={{ cursor: "pointer" }} onClick={() => { router(`/pages/${footerpage[0]?.slug}`) }}>*Terms & Conditions are apply
                            </span>
                        </h5>
                    </div>
                </div>
            </div>
        </section> : <section className='center_banner'>
            <div className='center_banner_img'>
                <img src='\assets\iocns\center_banner2.jpg' className='img-fluid' />
            </div>
        </section>}

        {/* qr-code-modal */}

        <section>
            <button type="button" className="btn btn-primary d-none" data-toggle="modal" data-target="#offlinebox" id='offlinepop-pup'>
                Launch demo modal
            </button>
            <div className="modal fade" id="offlinebox" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className='modal-content'>
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 schemename" id="razarpaypopupLabel"><span className='mx-2' style={{ cursor: 'pointer' }} onClick={() => { document.getElementById('offlinepop-pup').click(); document.getElementById('payment-pup').click() }}><ArrowLeft /></span>{shemData?.plan_title === "digital_plan" ? `${shemData?.name}(Cash Back)` : shemData?.plan_title === "gold_plant" ? `${shemData?.name}(Monthly Rental)` : shemData?.name}</h1>

                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('offlinepop-pup').click() }} ></button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex mb-2 mt-2 justify-content-center align-items-center gap-1" >
                                <img src="/assets/images/g-pay.png" alt="gpay" height={70} />
                                <img src="/assets/images/phone-pe.png" alt="phonepay" height={50} />

                                <div className="d-flex text-center align-items-center qr-upiid justify-content-between ">

                                    <h6 className="mb-0">{phonumber}</h6>
                                    <button
                                        className="btn btn-sm"
                                        style={{ fontSize: "1rem" }}
                                        onClick={() => handleCopy(phonumber, "phone")}
                                    >
                                        <FaCopy
                                            className={`${copiedField === "phone" ? "text-dark" : "text-secondary"}`}
                                        />
                                    </button>

                                    {/* <FaCopy className={`${copied ? "text-dark" : "text-secondary"} `}  onClick={() => handleCopy(upiId)} /> */}

                                </div>
                            </div>
                            <div className="qr-detail text-center">
                                <h6>{setting_data ? setting_data[0]?.account_holder : ''}</h6>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <div className="qr-upiid d-flex justify-content-center align-items-center">
                                    <button
                                        className="btn btn-sm"
                                        style={{ fontSize: "1rem" }}
                                        onClick={() => handleCopy(upiId, "upi")}
                                    >
                                        <FaCopy
                                            className={`${copiedField === "upi" ? "text-dark" : "text-secondary"}`}
                                        />
                                    </button>
                                    <h6 className="mb-0">{upiId}</h6>

                                    {/* <h6 className='mb-0'>Vyapar.171813426519@hdfcbank</h6> */}
                                </div>
                            </div>
                            <div className="qq-sacn-img p-2">
                                <img src={setting_data ? setting_data[0]?.qr_code : ''} alt='' className='img-fluid' />
                            </div>
                            <form onSubmit={upimethod}>
                                <div className="uplo-img ">
                                    <input type='file' className='d-none' id='scanimg' onChange={screenshot} />
                                    <button className='btn' type='button' onClick={() => { document.getElementById('scanimg').click() }}>Upload Payment ID PHOTO/IMAGE HERE <img src='\assets\iocns\upload.png' alt='' className='img-fluid' /></button>
                                    {!file1 && <span className="text-end d-block mt-2">
                                        <div
                                            className="d-flex align-items-center justify-content-end gap-2"
                                            style={{ cursor: "pointer" }}
                                            onClick={handleOpen}
                                        >
                                            <img
                                                src="/assets/iocns/eye.png"
                                                alt="preview"
                                                className="text-danger"
                                                style={{ width: "24px", height: "24px" }}
                                            />
                                            <span className="text-secondary">Example Transaction Slip</span>
                                        </div>
                                    </span>}

                                    {/* Bootstrap Modal */}
                                    <Modal show={showModal} onHide={handleClose} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Example Transaction Slip</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="text-center">
                                            <img
                                                src="/assets/images/example_slip.jfif"
                                                alt="Preview"
                                                style={{ maxWidth: "100%", maxHeight: "600px" }}
                                            />
                                        </Modal.Body>

                                    </Modal>
                                    {
                                        file1 ? (
                                            <>
                                                <div className='uploadfile-name position-relative'>
                                                    <p className='m-0'>{file1 ? `File Name : ${file1}` : ''}</p>
                                                    <h6 className='position-absolute remove-upload' onClick={() => { setfile1(); settransfile() }}><X /></h6>
                                                </div>
                                            </>
                                        ) : ''
                                    }

                                    <input type="text" className="form-control bg-white text-dark border text-center my-2" placeholder="SEND (or) PASTE SMS Transaction ID Here" aria-label="transaction-id" id='transaction-id' onChange={(e) => { setTranscationid(e.target.value) }} />
                                    <p className='text-danger '>* Upload the transaction slip or enter the transaction ID</p>
                                </div>
                                <div className="update-profile">
                                    <button className="text-white" type="submit">{spinner ? <span className="spinner-border spinner-border-sm " role="status"></span> : 'Continue'}</button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </section>


        <Snackbar
            open={openSnackbar}
            autoHideDuration={2000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
            <Alert onClose={handleCloseSnackbar} sx={{ width: "100%" }}>
                Copied to clipboard!
            </Alert>
        </Snackbar>
        {/* payment-modal */}

        <section>
            <button type="button" className="btn btn-primary d-none" data-toggle="modal" data-target="#paymentbox" id='payment-pup'>
                Launch demo modal
            </button>
            <div className="modal fade" id="paymentbox" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className='modal-content'>
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 schemename" id="razarpaypopupLabel">{shemData?.plan_title === "digital_plan" ? `${shemData?.name}(Cash Back)` : shemData?.plan_title === "gold_plant" ? `${shemData?.name}(Monthly Rental)` : shemData?.name}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('payment-pup').click() }} ></button>
                        </div>
                        <div className="modal-body">
                            <div className="pm-ti">
                                <h5> Choose Payment Method</h5>
                            </div>
                            <div className="pm-choice ">
                                <form onSubmit={paymentfun}>
                                    <div className={process_type == '2' ? 'form-check act' : 'form-check'} >
                                        <div className="selecttypes p-2  d-flex align-items-center gap-2">
                                            <input className="form-check-input  mb-1" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="2" onChange={(e) => { setprocess_type(e.target.value) }} />
                                            {/* <label className="form-check-label" htmlFor="inlineRadio2">QR code / UPI</label> */}
                                            <label className="form-check-label" htmlFor="inlineRadio2">Direct UPI Payments (QR Code) </label>
                                            <div className='razoricon'><img src='\assets\images\upis.png' className='img-fluid' alt='' /></div>
                                        </div>
                                    </div>
                                    <div className={process_type == '1' ? 'form-check act' : 'form-check'}>
                                        <div className="selecttypes p-2 d-flex align-items-center gap-2">
                                            <input className="form-check-input mb-1" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" onChange={(e) => { setprocess_type(e.target.value) }} />
                                            <label className="form-check-label" htmlFor="inlineRadio1">
                                                <div className='razoricon'>
                                                    <img src='\assets\images\visa.png' className='img-fluid' alt='' />
                                                    <img src='\assets\images\mascard.png' className='img-fluid' alt='' />
                                                    <img src='\assets\images\rupay.png' className='img-fluid' alt='' />
                                                    <img src='\assets\images\phopay.png' className='img-fluid' alt='' />
                                                    <img src='\assets\images\mastro.png' className='img-fluid' alt='' />
                                                </div>
                                            </label>

                                            {/* <div className='razoricon'>
                                                <img src='\assets\images\visa.png' className='img-fluid' alt='' />
                                                <img src='\assets\images\mascard.png' className='img-fluid' alt='' />
                                                <img src='\assets\images\rupay.png' className='img-fluid' alt='' />
                                                <img src='\assets\images\phopay.png' className='img-fluid' alt='' />
                                                <img src='\assets\images\mastro.png' className='img-fluid' alt='' />
                                            </div> */}
                                        </div>
                                    </div>

                                    <div className={process_type == '3' ? 'form-check act' : 'form-check'}>
                                        <div className="selecttypes py-3 px-2  d-flex align-items-center gap-2">
                                            <input className="form-check-input  mb-1" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="3" onChange={(e) => { setprocess_type(e.target.value) }} />
                                            {/* <label className="form-check-label" htmlFor="inlineRadio3">Bank Details</label> */}
                                            <label className="form-check-label" htmlFor="inlineRadio3">For RTGS / NEFT / IMPS</label>
                                            <div className='banic'><img src='assets\images\net_img.png' className='img-fluid' alt='' /></div>
                                        </div>
                                    </div>
                                    <div className="update-profile ">
                                        <button className="text-white" type="submit">Continue</button>
                                    </div>
                                </form>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </section>

        {/* bandetail-modal */}

        <section>
            <button type="button" className="btn btn-primary d-none" data-toggle="modal" data-target="#bankbox" id='bankpop-pup'>
                Launch demo modal
            </button>
            <div className="modal fade" id="bankbox" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className='modal-content'>
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 schemename" id="razarpaypopupLabel"><span className='mx-1' style={{ cursor: 'pointer' }} onClick={() => { document.getElementById('bankpop-pup').click(); document.getElementById('payment-pup').click() }}><ArrowLeft /></span> {shemData?.plan_title === "digital_plan" ? `${shemData?.name}(Cash Back)` : shemData?.plan_title === "gold_plant" ? `${shemData?.name}(Monthly Rental)` : shemData?.name} </h1>

                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('bankpop-pup').click() }} ></button>
                        </div>
                        <div className="modal-body ac-holdbank">
                            <h5 className='mb-4'>Bank Details</h5>

                            <div className="acc-holder">
                                <img src='\assets\iocns\Profile.png' className='img-fluid' alt='' /><span>Account Name : {setting_data ? setting_data[0]?.account_holder : ''}</span>
                            </div>
                            <div className="acc-holder">
                                <img src='\assets\iocns\accountnumber.png' className='img-fluid' alt='' /><span>Account Number : {setting_data ? setting_data[0]?.account_number : ''}</span>
                            </div>
                            <div className="acc-holder">
                                <img src='\assets\iocns\bank.png' className='img-fluid' alt='' /><span>Bank Name : {setting_data ? setting_data[0]?.bank_name : ''}</span>
                            </div>
                            <div className="acc-holder">
                                <img src='\assets\iocns\branchlocatin.png' className='img-fluid' alt='' /><span>Branch Name : {setting_data ? setting_data[0]?.branch_name : ''}</span>
                            </div>
                            <div className="acc-holder">
                                <img src='\assets\iocns\ifsc code.png' className='img-fluid' alt='' /><span>IFSC Code : {setting_data ? setting_data[0]?.ifsc_code : ''}</span>
                            </div>
                            <form onSubmit={Bankmethod}>

                                <div className="uplo-img text-start">
                                    <input type='file' className='d-none' id='scanimg' onChange={screenshot} />
                                    <button className='btn ' type='button' onClick={() => { document.getElementById('scanimg').click() }}>Upload Payment ID PHOTO/IMAGE HERE  <img src='\assets\iocns\upload.png' alt='' className='img-fluid' /></button>
                                    {
                                        file1 ? (
                                            <>
                                                <div className='uploadfile-name position-relative'>
                                                    <p className='m-0'>{file1 ? `File Name : ${file1}` : ''}</p>
                                                    <h6 className='position-absolute remove-upload' onClick={() => { setfile1(); settransfile() }}><X /></h6>
                                                </div>
                                            </>
                                        ) : ''
                                    }
                                    <input type="text" className="form-control bg-white text-dark border text-center my-2" placeholder="SEND (or) PASTE SMS Transaction ID Here" id='transaction-id2' aria-label="transaction-id" onChange={(e) => { setTranscationid(e.target.value) }} />
                                    <p className='text-danger '>* Upload the transaction slip or enter the transaction ID</p>
                                </div>

                                <div className="update-profile mt-2 mb-0">
                                    <button className="text-white" type="submit" >{spinner ? <span className="spinner-border spinner-border-sm " role="status"></span> : 'Continue'}</button>
                                </div>
                            </form>



                        </div>

                    </div>
                </div>
            </div>
        </section>

    </>
    )
}

const renderPlans = (plans) => {
    if (!plans || plans.length === 0) {
        return <p>No plans available.</p>;
    }

    return plans.map((plan) => (
        <div key={plan.id} className="active-plan-card mb-3">
            <img
                src={`/assets/images/${plan.image}`}
                alt={plan.name}
                className="plan-image"
            />
            <h3>{plan.name}</h3>
            <p>Tenure: {plan.plan_tenure} months</p>
            <p>Bonus: {plan.bonus}%</p>
            <p>Min Price: ₹{plan.min_price}</p>
            <p>Max Price: ₹{plan.max_price}</p>
            <p>Label: {plan.label}</p>
            {plan.page && (
                <a href={`/plans/${plan.page.slug}`} className="btn btn-primary">
                    View Terms & Conditions
                </a>
            )}
        </div>
    ));
};

